class WishlistButton extends HTMLElement {}

customElements.define('wishlist-button', WishlistButton);

var WE_PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
var WE_PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

function weFindVariantRow(variants, lookupId) {
  variants = variants || [];
  lookupId = String(lookupId || '');
  var index;

  for (index = 0; index < variants.length; index += 1) {
    if (String(variants[index].shopify_variant_id) === lookupId) {
      return variants[index];
    }
    if (String(variants[index].variant_id) === lookupId) {
      return variants[index];
    }
  }

  return null;
}

function weGetProductCache(lookupId) {
  lookupId = String(lookupId || '');

  try {
    var raw = sessionStorage.getItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + lookupId);

    if (raw) {
      return JSON.parse(raw);
    }

    raw = sessionStorage.getItem(WE_PRODUCT_CACHE_PREFIX + lookupId);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

function weCacheProductContext(payload) {
  payload = payload || {};

  try {
    var data = JSON.stringify(payload);

    if (payload.shopify_product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + String(payload.shopify_product_id), data);
    }

    if (payload.product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_PREFIX + String(payload.product_id), data);
    }
  } catch (error) {
    /* ignore */
  }
}

function weGetProductAnalyticsFromDom(shopifyProductId) {
  shopifyProductId = String(shopifyProductId || '');
  var selectors;
  var index;
  var node;
  var payload;

  if (!shopifyProductId) {
    return null;
  }

  selectors = [
    'script.webengage-product-analytics[data-product-id="' + shopifyProductId + '"]',
    'script.webengage-wishlist-analytics[data-product-id="' + shopifyProductId + '"]'
  ];

  for (index = 0; index < selectors.length; index += 1) {
    node = document.querySelector(selectors[index]);

    if (!node) {
      continue;
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      /* try next node */
    }
  }

  node = document.getElementById('webengage-product-payload');

  if (node) {
    try {
      payload = JSON.parse(node.textContent || '{}');

      if (String(payload.shopify_product_id) === shopifyProductId) {
        return payload;
      }
    } catch (error) {
      return null;
    }
  }

  return null;
}

function weMergeProductContextFields(cached, domBase) {
  cached = cached || {};
  domBase = domBase || {};
  var merged = {};
  var key;
  var specFields = ['fit', 'sleeve', 'material', 'gender', 'default_color', 'color'];
  var categoryFields = [
    'l1_category_name',
    'l2_category_name',
    'l1_category_id',
    'l2_category_id',
    'product_name',
    'image_url',
    'sub_brand_name',
    'section',
    'view_type'
  ];

  for (key in domBase) {
    if (Object.prototype.hasOwnProperty.call(domBase, key)) {
      merged[key] = domBase[key];
    }
  }

  for (key in cached) {
    if (Object.prototype.hasOwnProperty.call(cached, key)) {
      merged[key] = cached[key];
    }
  }

  specFields.forEach(function (field) {
    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }

    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }
  });

  categoryFields.forEach(function (field) {
    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }

    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }
  });

  if (!merged.variants || !merged.variants.length) {
    merged.variants = cached.variants || domBase.variants || [];
  }

  return merged;
}

function weGetProductContext(shopifyProductId) {
  var cached = weGetProductCache(shopifyProductId);
  var domBase = weGetProductAnalyticsFromDom(shopifyProductId);
  var merged;

  if (!domBase) {
    merged = cached || {};
  } else if (!cached || !cached.product_id) {
    merged = domBase;
  } else {
    merged = weMergeProductContextFields(cached, domBase);
  }

  weApplyCategoryFields(merged, weEnhanceProductCategories(merged));
  return merged;
}

function weSeedProductAnalyticsCacheFromDom(root) {
  root = root || document;
  var nodes = root.querySelectorAll(
    'script.webengage-product-analytics[data-product-id], script.webengage-wishlist-analytics[data-product-id]'
  );
  var payloadNode = root.getElementById ? root.getElementById('webengage-product-payload') : null;
  var index;

  for (index = 0; index < nodes.length; index += 1) {
    try {
      var payload = JSON.parse(nodes[index].textContent || '{}');
      weApplyCategoryFields(payload, weEnhanceProductCategories(payload));
      weCacheProductContext(payload);
    } catch (error) {
      /* ignore invalid JSON */
    }
  }

  if (payloadNode) {
    try {
      var pdpPayload = JSON.parse(payloadNode.textContent || '{}');
      weApplyCategoryFields(pdpPayload, weEnhanceProductCategories(pdpPayload));
      weCacheProductContext(pdpPayload);
    } catch (error) {
      /* ignore */
    }
  }
}

function weInitProductAnalyticsCacheSeeding() {
  weSeedProductAnalyticsCacheFromDom(document);

  if (!window.MutationObserver) {
    return;
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) {
          return;
        }

        weSeedProductAnalyticsCacheFromDom(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', weInitProductAnalyticsCacheSeeding);
} else {
  weInitProductAnalyticsCacheSeeding();
}

function weNormalizeImageUrl(url) {
  url = String(url || '').trim();

  if (!url) {
    return '';
  }

  if (url.indexOf('//') === 0) {
    return 'https:' + url;
  }

  return url;
}

function weResolveSubBrandName(gender, subBrandName, vendor) {
  if (String(gender || '').trim().toLowerCase() === 'boys') {
    return 'JJ JUNIOR';
  }

  return String(subBrandName || vendor || '').trim();
}

function weNormalizeProductPricing(mrp, totalPayable, discount) {
  mrp = Number(mrp) || 0;
  totalPayable = Number(totalPayable) || 0;
  discount = Number(discount);
  if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
    discount = mrp > totalPayable ? mrp - totalPayable : 0;
  }

  return {
    mrp: mrp,
    total_payable: totalPayable,
    discount_on_mrp: discount
  };
}

function weGetUsableProductCategories(source) {
  source = source || {};
  var l1 = source.l1_category_name || '';
  var l2 = source.l2_category_name || '';

  if (String(l1).trim().toLowerCase() === 'all products') {
    l1 = '';
  }

  if (String(l2).trim().toLowerCase() === 'all products') {
    l2 = '';
  }

  return {
    l1_category_name: l1,
    l2_category_name: l2,
    l1_category_id: l1 ? String(source.l1_category_id || '') : '',
    l2_category_id: l2 ? String(source.l2_category_id || '') : ''
  };
}

var WE_LAST_CATEGORY_VIEW_KEY = 'we_last_category_view';

function weReadJsonSession(key) {
  try {
    var raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function weEnhanceProductCategories(source) {
  source = weGetUsableProductCategories(source || {});
  var lastView = weReadJsonSession(WE_LAST_CATEGORY_VIEW_KEY);

  if (!lastView || !lastView.l1_category_name) {
    return source;
  }

  var onCollection = window.location.pathname.indexOf('/collections/') !== -1;
  var fromCollection = (document.referrer || '').indexOf('/collections/') !== -1;

  if (onCollection || fromCollection) {
    return {
      l1_category_name: lastView.l1_category_name,
      l2_category_name: lastView.l2_category_name || '',
      l1_category_id: String(lastView.l1_category_id || ''),
      l2_category_id: lastView.l2_category_id ? String(lastView.l2_category_id) : ''
    };
  }

  return source;
}

function weApplyCategoryFields(target, categories) {
  categories = categories || {};
  target.l1_category_name = categories.l1_category_name || '';
  target.l2_category_name = categories.l2_category_name || '';
  target.l1_category_id = String(categories.l1_category_id || '');
  target.l2_category_id = String(categories.l2_category_id || '');
  return target;
}

var WE_MULTI_PRODUCT_STRING_FIELDS = [
  'product_id',
  'product_name',
  'variant_id',
  'sub_brand_name',
  'l1_category_name',
  'l2_category_name',
  'l1_category_id',
  'l2_category_id',
  'color',
  'fit',
  'sleeve',
  'material',
  'gender',
  'size',
  'image_url'
];

function weAggregateProductDetailField(details, field) {
  var values = [];

  (details || []).forEach(function (item) {
    if (item[field]) {
      values.push(String(item[field]));
    }
  });

  return values.filter(function (value, index) {
    return values.indexOf(value) === index;
  }).join(', ');
}

function weApplyAggregatedProductFields(target, details, fields) {
  target = target || {};
  fields = fields || WE_MULTI_PRODUCT_STRING_FIELDS;

  fields.forEach(function (field) {
    target[field] = weAggregateProductDetailField(details, field);
  });

  return target;
}

document.addEventListener('variant:change', function (event) {
  var variant = event.detail && event.detail.variant;
  if (!variant || !variant.id) return;

  document.querySelectorAll('wishlist-button').forEach(function (button) {
    button.dataset.variantId = String(variant.id);
  });
});

(function () {
  var WISHLIST_API_BASE = 'https://livewishlist.scriptengine.net/api';
  var WISHLIST_STORE_ID_KEY = 'we_wishlist_store_id';
  var WISHLIST_ANALYTICS_VIEW = 'webengage-analytics';
  var WISHLIST_ENRICH_TIMEOUT_MS = 3500;
  var wishlistAnalyticsFetchCache = {};
  var lastWishlistViewedAt = 0;
  var lastWishlistActionKey = '';
  var lastWishlistActionAt = 0;

  function weShopifyRoot() {
    return typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function weJoinRootPath(root, path) {
    var normalizedRoot = String(root || '/').replace(/\/+$/, '') + '/';
    return normalizedRoot + String(path || '').replace(/^\/+/, '');
  }

  function extractHandleFromProductUrl(productUrl) {
    var match = String(productUrl || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getWishlistItemShopifyIds(item) {
    item = item || {};
    var productId = String(
      item.shopify_id || item.shopify_product_id || item.product_shopify_id || ''
    );
    var variantId = String(item.shopify_variant_id || item.variant_shopify_id || '');

    if (!productId && item.product_id && String(item.product_id).length > 8) {
      productId = String(item.product_id);
    }

    if (!variantId && item.variant_id && String(item.variant_id).length > 8) {
      variantId = String(item.variant_id);
    }

    return { shopifyProductId: productId, shopifyVariantId: variantId };
  }

  function buildWishlistDomShopifyIndex() {
    var index = {};
    var columns = document.querySelectorAll('[id^="wishlist_page_"]');
    var i;
    var col;
    var parts;
    var productId;
    var variantId;
    var link;
    var handle;

    for (i = 0; i < columns.length; i += 1) {
      col = columns[i];
      parts = col.id.split('_');

      if (parts.length < 4) {
        continue;
      }

      variantId = parts[parts.length - 1];
      productId = parts[parts.length - 2];

      if (!productId || !variantId) {
        continue;
      }

      handle = '';
      link = col.querySelector('a[href*="/products/"]');

      if (link) {
        handle = extractHandleFromProductUrl(link.getAttribute('href'));
      }

      index[productId] = {
        shopifyProductId: productId,
        shopifyVariantId: variantId,
        handle: handle
      };
    }

    return index;
  }

  function weIsProductAnalyticsCached(shopifyProductId) {
    var cached = weGetProductContext(shopifyProductId);
    return !!String(cached.product_id || '').trim();
  }

  function fetchProductAnalyticsPayload(handle) {
    handle = String(handle || '').trim();

    if (!handle) {
      return Promise.resolve(null);
    }

    if (wishlistAnalyticsFetchCache[handle]) {
      return wishlistAnalyticsFetchCache[handle];
    }

    var url = weJoinRootPath(
      weShopifyRoot(),
      'products/' + encodeURIComponent(handle) + '?view=' + WISHLIST_ANALYTICS_VIEW
    );

    wishlistAnalyticsFetchCache[handle] = fetch(url)
      .then(function (res) {
        if (!res.ok) {
          return null;
        }

        return res.text();
      })
      .then(function (text) {
        if (!text) {
          return null;
        }

        try {
          return JSON.parse(text.trim());
        } catch (error) {
          return null;
        }
      })
      .then(function (payload) {
        if (payload) {
          weApplyCategoryFields(payload, weEnhanceProductCategories(payload));
          weCacheProductContext(payload);
        }

        return payload;
      })
      .catch(function () {
        return null;
      });

    return wishlistAnalyticsFetchCache[handle];
  }

  function resolveProductHandle(shopifyProductId, shopifyVariantId, item, domIndex) {
    item = item || {};
    domIndex = domIndex || {};
    var handle = String(item.handle || item.product_handle || item.productHandle || '').trim();

    if (!handle) {
      handle = extractHandleFromProductUrl(
        item.product_url || item.url || item.link || item.product_link || ''
      );
    }

    if (!handle && domIndex[shopifyProductId] && domIndex[shopifyProductId].handle) {
      handle = domIndex[shopifyProductId].handle;
    }

    if (handle) {
      return Promise.resolve(handle);
    }

    function handleFromProductId(productId) {
      productId = String(productId || '').trim();

      if (!productId) {
        return Promise.resolve('');
      }

      var recUrl = weJoinRootPath(
        weShopifyRoot(),
        'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=1'
      );

      return fetch(recUrl)
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          var product = data && data.products && data.products[0];
          return product && product.handle ? String(product.handle) : '';
        })
        .catch(function () {
          return '';
        });
    }

    if (shopifyProductId) {
      return handleFromProductId(shopifyProductId);
    }

    if (shopifyVariantId) {
      var variantUrl = weJoinRootPath(
        weShopifyRoot(),
        'variants/' + encodeURIComponent(shopifyVariantId) + '.js'
      );

      return fetch(variantUrl)
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (variant) {
          return handleFromProductId(variant && variant.product_id);
        })
        .catch(function () {
          return '';
        });
    }

    return Promise.resolve('');
  }

  function enrichSingleWishlistItem(item, domIndex) {
    var ids = getWishlistItemShopifyIds(item);
    var shopifyProductId = ids.shopifyProductId;
    var shopifyVariantId = ids.shopifyVariantId;

    if (!shopifyProductId && domIndex) {
      Object.keys(domIndex).some(function (key) {
        if (String(item.shopify_variant_id || item.variant_id || '') === domIndex[key].shopifyVariantId) {
          shopifyProductId = domIndex[key].shopifyProductId;
          shopifyVariantId = domIndex[key].shopifyVariantId;
          return true;
        }

        return false;
      });
    }

    if (!shopifyProductId && !shopifyVariantId) {
      return Promise.resolve();
    }

    if (shopifyProductId && weIsProductAnalyticsCached(shopifyProductId)) {
      return Promise.resolve();
    }

    return resolveProductHandle(shopifyProductId, shopifyVariantId, item, domIndex).then(function (handle) {
      return fetchProductAnalyticsPayload(handle);
    });
  }

  function enrichWishlistDomProducts(domIndex) {
    domIndex = domIndex || {};

    return Object.keys(domIndex).map(function (productId) {
      if (weIsProductAnalyticsCached(productId)) {
        return Promise.resolve();
      }

      var row = domIndex[productId];
      var handlePromise = row.handle
        ? Promise.resolve(row.handle)
        : resolveProductHandle(productId, row.shopifyVariantId, {}, domIndex);

      return handlePromise.then(function (handle) {
        return fetchProductAnalyticsPayload(handle);
      });
    });
  }

  function enrichWishlistItemsForAnalytics(items, callback) {
    items = items || [];
    callback = callback || function () {};

    var domIndex = buildWishlistDomShopifyIndex();
    var finished = false;

    function done() {
      if (finished) {
        return;
      }

      finished = true;
      callback(items);
    }

    if (!items.length && !Object.keys(domIndex).length) {
      callback(items);
      return;
    }

    var timer = setTimeout(done, WISHLIST_ENRICH_TIMEOUT_MS);
    var tasks = items.map(function (item) {
      return enrichSingleWishlistItem(item, domIndex);
    }).concat(enrichWishlistDomProducts(domIndex));

    Promise.all(tasks)
      .then(function () {
        clearTimeout(timer);
        done();
      })
      .catch(function () {
        clearTimeout(timer);
        done();
      });
  }

  function getWishlistCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie.split(';');

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.substring(prefix.length));
        } catch (error) {
          return part.substring(prefix.length);
        }
      }
    }

    return '';
  }

  function getWishlistCustomerRecords() {
    var node = document.getElementById('wishlist-engine-customer-records');

    try {
      return JSON.parse((node && node.textContent) || '{}');
    } catch (error) {
      return {};
    }
  }

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function getWishlistTotalFromDom() {
    var node = document.querySelector('.wishlist-total-count');
    var total;

    if (node) {
      total = parseInt(node.getAttribute('data-total') || node.textContent, 10);
      if (!isNaN(total)) {
        return total;
      }
    }

    total = parseInt(getWishlistCookie('WISHLIST_TOTAL'), 10);
    return isNaN(total) ? 0 : total;
  }

  function buildWishlistRequestBody(extra) {
    var records = getWishlistCustomerRecords();
    var body = {
      uuid: getWishlistCookie('WISHLIST_UUID') || '',
      ip_address: getWishlistCookie('WISHLIST_IP_ADDRESS') || '',
      customer_id: records.id || '',
      customers: records,
      shopify_store_id: sessionStorage.getItem(WISHLIST_STORE_ID_KEY) || '',
      shopify_store: typeof Shopify !== 'undefined' ? Shopify.shop : '',
      search: '',
      active_currency: (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || '',
      share_id: '',
      shopify_local_language: (typeof Shopify !== 'undefined' && Shopify.locale) || 'en'
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        body[key] = extra[key];
      });
    }

    return body;
  }

  function wishlistApiPost(path, body) {
    return fetch(WISHLIST_API_BASE + path, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function ensureWishlistStoreId(callback) {
    var cached = sessionStorage.getItem(WISHLIST_STORE_ID_KEY);

    if (cached) {
      callback(cached);
      return;
    }

    wishlistApiPost('/apps-config', buildWishlistRequestBody({ shop: typeof Shopify !== 'undefined' ? Shopify.shop : '' }))
      .then(function (response) {
        var storeId = response && response.data && response.data.id ? String(response.data.id) : '';

        if (storeId) {
          sessionStorage.setItem(WISHLIST_STORE_ID_KEY, storeId);
        }

        callback(storeId);
      })
      .catch(function () {
        callback('');
      });
  }

  function mapWishlistApiItem(item) {
    item = item || {};
    var ids = getWishlistItemShopifyIds(item);
    var shopifyProductId = ids.shopifyProductId;
    var shopifyVariantId = ids.shopifyVariantId;

    if (!shopifyProductId) {
      shopifyProductId = String(item.shopify_id || '');
    }

    if (!shopifyVariantId) {
      shopifyVariantId = String(item.shopify_variant_id || '');
    }

    var cached = weGetProductContext(shopifyProductId);
    var variantRow = weFindVariantRow(cached.variants, shopifyVariantId);
    var categories =
      String(cached.product_id || '').trim() || String(cached.l1_category_name || '').trim()
        ? weEnhanceProductCategories(cached)
        : weGetUsableProductCategories(cached);
    var variants = item.variants || {};
    var variant = variants[shopifyVariantId] || variants[item.shopify_variant_id] || {};
    var price = Number(variant.price || item.price || 0);
    var compareAt = Number(variant.compare_at_price || variant.compare_at || price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = weNormalizeProductPricing(mrp, totalPayable, discountVal);
    var quantity = Number(item.quntity || item.quantity || 1);

    if (isNaN(quantity) || quantity <= 0) {
      quantity = 1;
    }

    var gender = cached.gender || '';

    return {
      product_id: String(cached.product_id || ''),
      product_name: cached.product_name || item.title || item.product_name || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || ''),
      shopify_product_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      image_url: variant.image_src || item.image || cached.image_url || '',
      sub_brand_name: weResolveSubBrandName(gender, cached.sub_brand_name, item.vendor),
      l1_category_name: categories.l1_category_name,
      l2_category_name: categories.l2_category_name,
      l1_category_id: categories.l1_category_id,
      l2_category_id: categories.l2_category_id,
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow ? !!variantRow.in_stock : (cached.in_stock !== undefined ? !!cached.in_stock : true),
      color: (variantRow && variantRow.color) || cached.color || '',
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: gender,
      size: (variantRow && variantRow.size) || cached.size || '',
      section: cached.section || '',
      view_type: cached.view_type || 'normal',
      quantity: quantity
    };
  }

  function mapWishlistActionPayload(product) {
    if (!product) {
      return null;
    }

    var shopifyProductId = String(product.shopify_id || product.product_id || product.id || '');
    var shopifyVariantId = String(product.shopify_variant_id || product.variant_id || product.variant || '');
    var cached = weGetProductContext(shopifyProductId);
    var payload = mapWishlistApiItem({
      shopify_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      title: product.title || product.product_name || product.name,
      product_name: product.product_name || product.name,
      sku: product.sku,
      price: product.price,
      compare_at_price: product.compare_at_price || product.compare_at,
      vendor: product.vendor,
      image: product.image || product.image_src,
      quantity: product.quntity || product.quantity || 1,
      variants: product.variants || {}
    });

    payload.shopify_product_id = shopifyProductId;
    payload.shopify_variant_id = shopifyVariantId;
    payload.variants = (cached && cached.variants) || [];
    return payload;
  }

  function mapWishlistCallbackProduct(product) {
    var payload = mapWishlistActionPayload(product);

    if (!payload) {
      return null;
    }

    return {
      product_id: payload.product_id,
      product_name: payload.product_name,
      variant_id: payload.variant_id
    };
  }

  function buildWishlistSummary(items, meta) {
    var productDetails = [];
    var subtotal = 0;
    var index;

    items = items || [];
    meta = meta || {};

    for (index = 0; index < items.length; index += 1) {
      var mapped = mapWishlistApiItem(items[index]);

      if (!String(mapped.product_id || '').trim() || !String(mapped.variant_id || '').trim()) {
        continue;
      }

      productDetails.push(mapped);
      subtotal += mapped.total_payable * (mapped.quantity || 1);
    }

    subtotal = Math.round(subtotal * 100) / 100;

    var totalCount = productDetails.length;

    if (!totalCount) {
      totalCount = Number(meta.total_items_in_wishlist);

      if (isNaN(totalCount)) {
        totalCount = 0;
      }
    }

    var summary = {
      total_items_in_wishlist: totalCount,
      subtotal: subtotal,
      total_payable: subtotal,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(summary, productDetails);

    if (meta.action) {
      summary.action = meta.action;
    }

    return summary;
  }

  function fetchWishlistItems(callback) {
    ensureWishlistStoreId(function (storeId) {
      var body = buildWishlistRequestBody();
      body.shopify_store_id = storeId;

      wishlistApiPost('/apps-wishlist', body)
        .then(function (response) {
          callback((response && response.data) || []);
        })
        .catch(function () {
          wishlistApiPost('/get-all-product', body)
            .then(function (fallbackResponse) {
              callback((fallbackResponse && fallbackResponse.data) || []);
            })
            .catch(function () {
              callback([]);
            });
        });
    });
  }

  function publishWishlistUpdated(action, changedProduct) {
    fetchWishlistItems(function (items) {
      var meta = {
        action: action,
        total_items_in_wishlist: getWishlistTotalFromDom() || items.length
      };

      if (changedProduct) {
        meta.product_id = changedProduct.product_id;
        meta.product_name = changedProduct.product_name;
        meta.variant_id = changedProduct.variant_id;
      }

      enrichWishlistItemsForAnalytics(items, function () {
        var summary = buildWishlistSummary(items, meta);

        if (!summary.product_details.length) {
          return;
        }

        publishAnalyticsEvent('bestseller:wishlist_updated', summary);
      });
    });
  }

  function publishWishlistViewed() {
    var now = Date.now();

    if (now - lastWishlistViewedAt < 2000) {
      return;
    }

    fetchWishlistItems(function (items) {
      enrichWishlistItemsForAnalytics(items, function () {
        lastWishlistViewedAt = Date.now();
        var summary = buildWishlistSummary(items, {
          total_items_in_wishlist: getWishlistTotalFromDom() || items.length
        });

        if (!summary.product_details.length) {
          return;
        }

        publishAnalyticsEvent('bestseller:wishlist_viewed', summary);
      });
    });
  }

  function isWishlistPage() {
    var path = window.location.pathname;
    return path === '/pages/wishlist' || path.indexOf('/apps/wishlist') === 0;
  }

  function initWishlistPageViewTracking() {
    if (!isWishlistPage()) {
      return;
    }

    var published = false;

    function schedulePublish() {
      if (published) {
        return;
      }

      published = true;
      setTimeout(publishWishlistViewed, 800);
    }

    var observer = new MutationObserver(function () {
      var container = document.querySelector('.wishlistajaxLoad, .wishlist-row');

      if (
        container &&
        container.querySelector('[id^="wishlist_page_"], .wh-list-column, .wh-grid-column, .wishlsitnoitem')
      ) {
        schedulePublish();
      }
    });

    var page = document.querySelector('.wishlist-page');

    if (page) {
      observer.observe(page, { childList: true, subtree: true });
    }

    setTimeout(schedulePublish, 2500);
  }

  function shouldPublishWishlistAction(action, payload) {
    if (!payload) {
      return false;
    }

    var key =
      action +
      ':' +
      String(payload.shopify_product_id || payload.product_id || '') +
      ':' +
      String(payload.shopify_variant_id || payload.variant_id || '');
    var now = Date.now();

    if (key && key === lastWishlistActionKey && now - lastWishlistActionAt < 3000) {
      return false;
    }

    lastWishlistActionKey = key;
    lastWishlistActionAt = now;
    return true;
  }

  window.wishlistCallback = function (data) {
    data = data || {};
    var actionMap = {
      ADD: 'add',
      REMOVE: 'remove',
      MOVETOCART: 'move_to_cart'
    };
    var action = actionMap[data.event] || String(data.event || '').toLowerCase();
    var actionPayload = mapWishlistActionPayload(data.product);

    if (action === 'add' && shouldPublishWishlistAction('add', actionPayload)) {
      publishAnalyticsEvent('add_to_wishlist', actionPayload);
    } else if (action === 'remove' && shouldPublishWishlistAction('remove', actionPayload)) {
      publishAnalyticsEvent('remove_from_wishlist', actionPayload);
    }

    setTimeout(function () {
      publishWishlistUpdated(action, mapWishlistCallbackProduct(data.product));
    }, 300);

    if (action === 'move_to_cart') {
      setTimeout(function () {
        if (typeof window.__wePublishCartUpdated === 'function') {
          window.__wePublishCartUpdated(null, 'move_to_cart');
        }
      }, 500);
    }
  };

  window.__weProductAnalytics = {
    enrichTimeout: WISHLIST_ENRICH_TIMEOUT_MS,
    isCached: weIsProductAnalyticsCached,
    fetchByHandle: fetchProductAnalyticsPayload,
    resolveHandle: resolveProductHandle
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPageViewTracking);
  } else {
    initWishlistPageViewTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

  function findVariantRow(variants, lookupId) {
    variants = variants || [];
    lookupId = String(lookupId || '');
    var index;

    for (index = 0; index < variants.length; index += 1) {
      if (String(variants[index].shopify_variant_id) === lookupId) {
        return variants[index];
      }
      if (String(variants[index].variant_id) === lookupId) {
        return variants[index];
      }
    }

    return null;
  }

  function getThemeProductCache(productId) {
    productId = String(productId || '');

    try {
      var raw = sessionStorage.getItem(PRODUCT_CACHE_SHOPIFY_PREFIX + productId);

      if (raw) {
        return JSON.parse(raw);
      }

      raw = sessionStorage.getItem(PRODUCT_CACHE_PREFIX + productId);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function centsToAmount(cents) {
    return Number(cents || 0) / 100;
  }

  function normalizeProductPricing(mrp, totalPayable, discount) {
    mrp = Number(mrp) || 0;
    totalPayable = Number(totalPayable) || 0;
    discount = Number(discount);
    if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
      discount = mrp > totalPayable ? mrp - totalPayable : 0;
    }

    return {
      mrp: mrp,
      total_payable: totalPayable,
      discount_on_mrp: discount
    };
  }

  function resolveCartVariantRow(cached, item) {
    cached = cached || {};
    item = item || {};
    var variants = cached.variants || [];
    var variantRow = findVariantRow(variants, item.variant_id);

    if (!variantRow && item.sku) {
      variantRow = findVariantRow(variants, item.sku);
    }

    return variantRow;
  }

  function mapCartLineForCheckout(item) {
    item = item || {};
    var shopifyProductId = String(item.product_id || '');
    var shopifyVariantId = String(item.variant_id || '');
    var cached = weGetProductContext(shopifyProductId);
    var variantRow = resolveCartVariantRow(cached, item);
    var price = centsToAmount(item.final_price != null ? item.final_price : item.price);
    var compareAt = centsToAmount(
      item.original_price != null ? item.original_price : (item.compare_at_price || item.price)
    );
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp;
    var totalPayable;
    var discountVal;

    if (variantRow) {
      mrp = Number(variantRow.mrp) || compareAt || price;
      totalPayable = Number(variantRow.total_payable) || price;
      discountVal =
        variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
          ? Number(variantRow.discount_on_mrp)
          : lineDiscount;
    } else {
      mrp = compareAt || price;
      totalPayable = price;
      discountVal = lineDiscount;
    }

    var pricing = normalizeProductPricing(mrp, totalPayable, discountVal);
    var gender = cached.gender || '';
    var color = (variantRow && variantRow.color) || cached.color || cached.default_color || '';

    return {
      shopify_product_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      product_id: String(cached.product_id || ''),
      product_name: cached.product_name || item.product_title || item.title || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || shopifyVariantId || ''),
      image_url: item.image || item.featured_image || cached.image_url || '',
      sub_brand_name: weResolveSubBrandName(gender, cached.sub_brand_name, item.vendor),
      l1_category_name: cached.l1_category_name || '',
      l2_category_name: cached.l2_category_name || '',
      l1_category_id: String(cached.l1_category_id || ''),
      l2_category_id: String(cached.l2_category_id || ''),
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow ? !!variantRow.in_stock : (cached.in_stock !== undefined ? !!cached.in_stock : true),
      color: color,
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: gender,
      size: (variantRow && variantRow.size) || item.variant_title || cached.size || '',
      quantity: Number(item.quantity) || 1
    };
  }

  function enrichCartItemsForAnalytics(items, callback) {
    items = items || [];
    callback = callback || function () {};

    var api = window.__weProductAnalytics;

    if (!api || !items.length) {
      callback();
      return;
    }

    var finished = false;

    function done() {
      if (finished) {
        return;
      }

      finished = true;
      callback();
    }

    var timer = setTimeout(done, api.enrichTimeout || 3500);
    var tasks = items.map(function (item) {
      var shopifyProductId = String(item.product_id || '');

      if (!shopifyProductId || api.isCached(shopifyProductId)) {
        return Promise.resolve();
      }

      return api
        .resolveHandle(shopifyProductId, String(item.variant_id || ''), item, {})
        .then(function (handle) {
          return api.fetchByHandle(handle);
        });
    });

    Promise.all(tasks)
      .then(function () {
        clearTimeout(timer);
        done();
      })
      .catch(function () {
        clearTimeout(timer);
        done();
      });
  }

  var lastCartLinesByKey = {};

  function snapshotCartLines(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    var i;
    var item;
    var key;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      map[key] = item;
    }

    return map;
  }

  function findChangedCartLine(cart) {
    var items = (cart && cart.items) || [];
    var next = snapshotCartLines(cart);
    var i;
    var item;
    var key;
    var prev;
    var changed = null;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      prev = lastCartLinesByKey[key];

      if (!prev || Number(prev.quantity) !== Number(item.quantity)) {
        changed = item;
        break;
      }
    }

    if (!changed) {
      for (key in lastCartLinesByKey) {
        if (!Object.prototype.hasOwnProperty.call(lastCartLinesByKey, key)) {
          continue;
        }

        if (!next[key]) {
          changed = lastCartLinesByKey[key];
          break;
        }
      }
    }

    lastCartLinesByKey = next;
    return changed || items[0] || null;
  }

  function getCheckoutItemsCount(details, fallback) {
    var total = 0;

    (details || []).forEach(function (item) {
      total += Number(item.quantity) || 1;
    });

    if (total) {
      return total;
    }

    return Number(fallback) || 0;
  }

  function getCartDiscountBreakdown(cart) {
    cart = cart || {};
    var apps = cart.cart_level_discount_applications || [];
    var couponNames = [];
    var appCouponValue = 0;
    var promoNames = [];
    var appPromoValue = 0;
    var allocationCouponValue = 0;
    var allocationPromoValue = 0;
    var index;

    for (index = 0; index < apps.length; index += 1) {
      var app = apps[index];
      var title = app.title || '';
      var amount = centsToAmount(app.total_allocated_amount || 0);
      var type = String(app.type || '').toLowerCase();

      if (type === 'discount_code' || type === 'code') {
        if (title) {
          couponNames.push(title);
        }
        appCouponValue += amount;
      } else {
        if (title) {
          promoNames.push(title);
        }
        appPromoValue += amount;
      }
    }

    (cart.items || []).forEach(function (item) {
      var allocations = item.line_level_discount_allocations || item.discount_allocations || [];

      allocations.forEach(function (allocation) {
        var discountApp = allocation.discount_application || allocation.discountApplication || {};
        var value = centsToAmount(allocation.amount || 0);
        var discountType = String(discountApp.type || '').toLowerCase();
        var discountTitle = discountApp.title || '';

        if (discountType === 'discount_code' || discountType === 'code') {
          if (discountTitle && couponNames.indexOf(discountTitle) === -1) {
            couponNames.push(discountTitle);
          }
          allocationCouponValue += value;
        } else {
          if (discountTitle && promoNames.indexOf(discountTitle) === -1) {
            promoNames.push(discountTitle);
          }
          allocationPromoValue += value;
        }
      });
    });

    var couponValue = allocationCouponValue > 0 ? allocationCouponValue : appCouponValue;
    var promoValue = allocationPromoValue > 0 ? allocationPromoValue : appPromoValue;
    var totalDiscount = centsToAmount(cart.total_discount || 0);

    if (totalDiscount > 0 && couponValue === 0 && promoValue === 0) {
      if (promoNames.length) {
        promoValue = totalDiscount;
      } else if (couponNames.length) {
        couponValue = totalDiscount;
      } else {
        promoValue = totalDiscount;
      }
    }

    return {
      coupon_name: couponNames.join(', '),
      coupon_value: couponValue,
      promotion_name: promoNames.join(', '),
      promotion_value: promoValue
    };
  }

  function buildCheckoutPayloadFromCart(cart) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var discounts = getCartDiscountBreakdown(cart);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    var payload = {
      cart_id: String(cart.token || ''),
      total_items_in_cart: getCheckoutItemsCount(productDetails, cart.item_count),
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      coupon_name: discounts.coupon_name,
      coupon_value: discounts.coupon_value,
      promotion_name: discounts.promotion_name,
      promotion_value: discounts.promotion_value,
      checkout_url: '',
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCheckoutInitiatedFromCart() {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        enrichCartItemsForAnalytics(cart.items || [], function () {
          Shopify.analytics.publish('bestseller:checkout_initiated', buildCheckoutPayloadFromCart(cart));
        });
      })
      .catch(function () {});
  }

  function buildCartSummaryFromCart(cart, changedLine) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;
    var payload;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    payload = {
      cart_id: String(cart.token || ''),
      total_items_in_cart: Number(cart.item_count) || 0,
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCartUpdatedPayload(cart, action) {
    var payload;

    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    enrichCartItemsForAnalytics(cart.items, function () {
      payload = buildCartSummaryFromCart(cart, findChangedCartLine(cart));

      if (action) {
        payload.action = action;
      }

      if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
        return;
      }

      Shopify.analytics.publish('bestseller:cart_updated', payload);
    });
  }

  window.__wePublishCartUpdated = function (cart, action) {
    if (cart && Array.isArray(cart.items)) {
      publishCartUpdatedPayload(cart, action);
      return;
    }

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        publishCartUpdatedPayload(cartData, action);
      })
      .catch(function () {});
  };

  function publishCartAnalyticsEvent(eventName, cart) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    enrichCartItemsForAnalytics(cart.items, function () {
      Shopify.analytics.publish(eventName, buildCartSummaryFromCart(cart, cart.items[0] || null));
    });
  }

  function fetchAndPublishCartAnalytics(eventName) {
    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) {
          return response.json();
        })
      .then(function (cart) {
        enrichCartItemsForAnalytics(cart.items || [], function () {
          if (eventName === 'bestseller:cart_updated') {
            Shopify.analytics.publish(eventName, buildCartSummaryFromCart(cart, findChangedCartLine(cart)));
            return;
          }

          if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
            return;
          }

          Shopify.analytics.publish(eventName, buildCartSummaryFromCart(cart, cart.items[0] || null));
        });
      })
      .catch(function () {});
  }

  var lastCartViewedAt = 0;

  function publishCartViewed(cart) {
    var now = Date.now();

    if (now - lastCartViewedAt < 2000) {
      return;
    }

    lastCartViewedAt = now;

    if (cart && Array.isArray(cart.items)) {
      publishCartAnalyticsEvent('bestseller:cart_viewed', cart);
      return;
    }

    fetchAndPublishCartAnalytics('bestseller:cart_viewed');
  }

  function getCartActionFromBaseEvent(baseEvent) {
    if (baseEvent === 'variant:add') {
      return 'add';
    }

    if (baseEvent === 'line-item:change') {
      return 'update';
    }

    return '';
  }

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    var cart = detail.cart;

    if (!cart || !Array.isArray(cart.items)) {
      fetchAndPublishCartAnalytics('bestseller:cart_updated');
      return;
    }

    publishCartUpdatedPayload(
      cart,
      getCartActionFromBaseEvent(detail.baseEvent) || ''
    );
  });

  window.addEventListener('view_cart', function () {
    publishCartViewed();
  });

  function initCartPageViewTracking() {
    var path = window.location.pathname;

    if (path !== '/cart' && path.indexOf('/cart/') !== 0) {
      return;
    }

    setTimeout(function () {
      publishCartViewed();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPageViewTracking);
  } else {
    initCartPageViewTracking();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');

      if (!target) {
        return;
      }

      if (target.tagName === 'A' && target.href && target.href.indexOf('/checkout') === -1) {
        return;
      }

      publishCheckoutInitiatedFromCart();
    },
    true
  );
})();

(function () {
  var lastProductSearchedKey = '';

  function publishProductSearchedEvent(payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish('bestseller:product_searched', payload);
  }

  function getSearchTermFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('q') || params.get('query') || '').trim();
    } catch (error) {
      return '';
    }
  }

  function getProductCountFromTitle() {
    var title = document.title || '';
    var match = title.match(/(\d+)\s+results?\s+found/i);

    if (!match) {
      return null;
    }

    return parseInt(match[1], 10);
  }

  function isSearchPage() {
    var path = window.location.pathname;
    return path === '/search' || path.indexOf('/search/') === 0;
  }

  function shouldSkipProductSearched(searchTerm) {
    var key = String(searchTerm).toLowerCase();

    if (lastProductSearchedKey === key) {
      return true;
    }

    lastProductSearchedKey = key;
    return false;
  }

  function publishProductSearchedFromSearchPage() {
    if (!isSearchPage()) {
      return false;
    }

    var searchTerm = getSearchTermFromUrl();
    var productCount = getProductCountFromTitle();

    if (!searchTerm || productCount === null || isNaN(productCount)) {
      return false;
    }

    if (shouldSkipProductSearched(searchTerm)) {
      return true;
    }

    publishProductSearchedEvent({
      search_term: searchTerm,
      product_count: productCount
    });

    return true;
  }

  function initSearchPageTracking() {
    if (!isSearchPage()) {
      return;
    }

    if (publishProductSearchedFromSearchPage()) {
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (publishProductSearchedFromSearchPage() || attempts >= 8) {
        window.clearInterval(interval);
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPageTracking);
  } else {
    initSearchPageTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var lastProductViewedKey = '';
  var lastProductViewedAt = 0;

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function resolveProductViewSection(explicitSection, basePayload) {
    if (explicitSection) {
      return explicitSection;
    }

    if (basePayload && basePayload.section) {
      return basePayload.section;
    }

    var path = window.location.pathname;

    if (path.indexOf('/products/') !== -1) {
      var ref = document.referrer || '';

      try {
        var refUrl = new URL(ref);

        if (refUrl.hostname === window.location.hostname) {
          if (refUrl.pathname.indexOf('/collections/') !== -1) {
            return 'PLP';
          }

          if (refUrl.pathname === '/' || refUrl.pathname === '') {
            return 'Home';
          }
        }
      } catch (error) {
        /* ignore */
      }

      return 'PDP';
    }

    return 'PLP';
  }

  function getCartItemCount(callback) {
    var cartCountNode = document.querySelector('cart-count');

    if (cartCountNode) {
      var domCount = parseInt(String(cartCountNode.textContent || '').trim(), 10);

      if (!isNaN(domCount)) {
        callback(domCount);
        return;
      }
    }

    var root = typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        callback(Number(cart.item_count) || 0);
      })
      .catch(function () {
        callback(0);
      });
  }

  function buildProductViewedPayload(basePayload, variantId, options) {
    basePayload = basePayload || {};
    options = options || {};

    var variantRow = weFindVariantRow(basePayload.variants, variantId);

    if (!variantRow) {
      variantRow = (basePayload.variants || [])[0] || {};
    }

    var categories = weEnhanceProductCategories(basePayload);

    return {
      product_id: String(basePayload.product_id || ''),
      shopify_product_id: String(basePayload.shopify_product_id || ''),
      shopify_variant_id: String(variantRow.shopify_variant_id || variantId || ''),
      product_name: basePayload.product_name || '',
      image_url: weNormalizeImageUrl(basePayload.image_url),
      sub_brand_name: basePayload.sub_brand_name || '',
      l1_category_name: categories.l1_category_name || '',
      l2_category_name: categories.l2_category_name || '',
      l1_category_id: String(categories.l1_category_id || ''),
      l2_category_id: String(categories.l2_category_id || ''),
      section: resolveProductViewSection(options.section, basePayload),
      view_type: options.view_type || basePayload.view_type || 'normal',
      variant_id: String(variantRow.variant_id || variantId || ''),
      mrp: Number(variantRow.mrp) || 0,
      total_payable: Number(variantRow.total_payable) || 0,
      discount_on_mrp: Number(variantRow.discount_on_mrp) || 0,
      in_stock: !!variantRow.in_stock,
      size: variantRow.size || '',
      color: variantRow.color || basePayload.default_color || '',
      fit: basePayload.fit || '',
      sleeve: basePayload.sleeve || '',
      material: basePayload.material || '',
      gender: basePayload.gender || '',
      total_items_in_cart: Number(options.total_items_in_cart) || 0,
      variants: basePayload.variants || []
    };
  }

  function shouldSkipProductViewed(payload) {
    var key = String(payload.product_id) + ':' + String(payload.section);
    var now = Date.now();

    if (lastProductViewedKey === key && now - lastProductViewedAt < 2000) {
      return true;
    }

    lastProductViewedKey = key;
    lastProductViewedAt = now;
    return false;
  }

  window.__wePublishProductViewed = function (basePayload, variantId, options) {
    getCartItemCount(function (cartCount) {
      options = options || {};
      options.total_items_in_cart = cartCount;

      var payload = buildProductViewedPayload(basePayload, variantId, options);

      if (shouldSkipProductViewed(payload)) {
        return;
      }

      publishAnalyticsEvent('bestseller:product_viewed', payload);
      weCacheProductContext(payload);
    });
  };

  document.addEventListener(
    'click',
    function (event) {
      var quickBuyButton = event.target.closest('.product-card__quick-add-button');

      if (!quickBuyButton) {
        return;
      }

      var card = quickBuyButton.closest('product-card');

      if (!card) {
        return;
      }

      var analyticsNode = card.querySelector('script.webengage-product-analytics');

      if (!analyticsNode) {
        return;
      }

      try {
        var basePayload = JSON.parse(analyticsNode.textContent || '{}');
        var variants = basePayload.variants || [];
        var variantRow = variants[0] || {};

        window.__wePublishProductViewed(basePayload, variantRow.shopify_variant_id || variantRow.variant_id, {
          section: basePayload.section || 'PLP',
          view_type: 'quick'
        });
      } catch (error) {
        /* ignore */
      }
    },
    true
  );
})();
/**
 * Collection quick category sticky bar behavior
 * - scrolling down: hide
 * - scrolling up: show
 * - scroll stop: show
 */
(function initCollectionQuickCategoryStickyBar() {
  const DESKTOP_BAR_SELECTOR = '.quick_category.hide_on_mob';
  const MOBILE_BAR_SELECTOR = '.collection-toolbar';
  const DESKTOP_MQ = '(min-width: 1000px)';
  const MOBILE_MQ = '(max-width: 999px)';

  const getStickyAreaHeight = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height').trim();
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const setupOne = ({ barSelector, mediaQuery }) => {
    const bar = document.querySelector(barSelector);
    if (!bar) return;

    const mq = window.matchMedia(mediaQuery);
    let lastY = window.scrollY || 0;
    let pendingY = lastY;
    let rafId = 0;
    let scrollStopTimer = 0;
    let abortController = null;
    let isHidden = false;
    let isStuck = false;
    let lastDirection = 0; // 1 = down, -1 = up

    const show = () => {
      if (!isHidden) return;
      isHidden = false;
      bar.classList.remove('is-hidden');
    };
    const hide = () => {
      if (isHidden) return;
      isHidden = true;
      bar.classList.add('is-hidden');
    };

    const setStuck = (next) => {
      if (isStuck === next) return;
      isStuck = next;
      bar.classList.toggle('is-stuck', isStuck);

      // When not stuck, always show the bar (avoid weird hidden state near the top).
      if (!isStuck) show();
    };

    const updateStuckState = () => {
      const stickyTop = getStickyAreaHeight();
      const top = bar.getBoundingClientRect().top;

      // Hysteresis prevents flicker near the sticky threshold.
      const STUCK_ENTER_PX = 1;
      const STUCK_LEAVE_PX = 12;

      if (!isStuck) {
        if (top <= stickyTop + STUCK_ENTER_PX) setStuck(true);
      } else {
        if (top > stickyTop + STUCK_LEAVE_PX) setStuck(false);
      }
    };

    const scheduleScrollStopShow = () => {
      window.clearTimeout(scrollStopTimer);
      // Slightly longer debounce avoids flashing on tiny scroll pauses (trackpads/inertia).
      scrollStopTimer = window.setTimeout(() => {
        // Only force-show when the bar is in sticky mode.
        if (isStuck) show();
      }, 260);
    };

    const processScroll = () => {
      rafId = 0;
      const y = pendingY;
      const delta = y - lastY;
      lastY = y;

      updateStuckState();

      // Before the bar becomes sticky, keep it stable (no hide/show).
      if (!isStuck) return;

      const DIRECTION_THRESHOLD = 6;
      if (delta > DIRECTION_THRESHOLD) {
        lastDirection = 1;
        hide();
      } else if (delta < -DIRECTION_THRESHOLD) {
        lastDirection = -1;
        show();
      } else {
        // Ignore micro-movements to prevent jitter.
      }

      // Requirement: when scrolling stops, the bar should show (even if last direction was down).
      scheduleScrollStopShow();
    };

    const onScroll = () => {
      pendingY = window.scrollY || 0;
      if (!rafId) rafId = requestAnimationFrame(processScroll);
    };

    const enable = () => {
      lastY = window.scrollY || 0;
      pendingY = lastY;
      isHidden = bar.classList.contains('is-hidden');
      isStuck = bar.classList.contains('is-stuck');
      lastDirection = 0;
      show();
      updateStuckState();

      abortController?.abort();
      abortController = new AbortController();

      window.addEventListener('scroll', onScroll, { passive: true, signal: abortController.signal });
    };

    const disable = () => {
      abortController?.abort();
      abortController = null;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      window.clearTimeout(scrollStopTimer);
      scrollStopTimer = 0;
      show();
      setStuck(false);
    };

    const onMqChange = () => {
      if (mq.matches) enable();
      else disable();
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      // Legacy Safari
      mq.addListener(onMqChange);
    }

    onMqChange();
  };

  const setup = () => {
    setupOne({ barSelector: DESKTOP_BAR_SELECTOR, mediaQuery: DESKTOP_MQ });
    setupOne({ barSelector: MOBILE_BAR_SELECTOR, mediaQuery: MOBILE_MQ });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.querySelector('[data-back-to-top]');

  if (!backToTopButton) return;

  var SHOW_OFFSET = 400; // pixels

  function toggleBackToTopVisibility() {
    if (window.scrollY > SHOW_OFFSET) {
      backToTopButton.classList.add('back-to-top--visible');
    } else {
      backToTopButton.classList.remove('back-to-top--visible');
    }
  }

  window.addEventListener('scroll', toggleBackToTopVisibility, { passive: true });

  toggleBackToTopVisibility();

  backToTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});


// -----------------------------------------------------------------------------
// CUSTOMER INVOICE LIST (ONLINE / OFFLINE)
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var invoiceSection = document.querySelector('.invoice-section[data-invoice-endpoint]');
  if (!invoiceSection) return;

  var phone = invoiceSection.getAttribute('data-invoice-phone') || '';
  var store = invoiceSection.getAttribute('data-invoice-store') || '';
  var endpoint = invoiceSection.getAttribute('data-invoice-endpoint') || '';

  // If phone is missing, Liquid has already rendered a helpful message.
  if (!phone || !endpoint || !store) return;

  var cache = {
    online: null,
    offline: null
  };
  var currentType = 'online';

  var tabs = invoiceSection.querySelectorAll('.invoice-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.getAttribute('data-invoice-type');
      if (!type || type === currentType) return;

      currentType = type;
      tabs.forEach(function (innerTab) {
        innerTab.classList.toggle('is-active', innerTab === tab);
      });

      loadInvoices(type);
    });
  });

  // Load Website (online) by default
  loadInvoices('online');

  function loadInvoices(type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var errorEl = invoiceSection.querySelector('.invoice-error');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    var table = invoiceSection.querySelector('.invoice-table');
    if (!tbody || !errorEl) return;

    if (table) {
      table.classList.toggle('invoice-table--offline', type === 'offline');
    }

    errorEl.style.display = 'none';
    errorEl.textContent = '';
    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }
    tbody.innerHTML =
      '<tr><td colspan="6">Loading ' + (type === 'online' ? 'website' : 'offline') + ' invoices&hellip;</td></tr>';

    if (cache[type]) {
      renderInvoices(cache[type], type);
      return;
    }

    try {
      var url = new URL(endpoint);
      url.searchParams.set('phone', phone);
      url.searchParams.set('store', store);
      url.searchParams.set('type', type);

      // Do not send credentials so the API can use a simple wildcard CORS policy.
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success !== true || !Array.isArray(data.data)) {
            throw new Error('Unexpected API response');
          }

          cache[type] = data.data;
          renderInvoices(cache[type], type);
        })
        .catch(function (error) {
          console.error('Error fetching invoices', error);
          tbody.innerHTML = '';
          errorEl.textContent = 'Unable to load invoices at the moment. Please try again later.';
          errorEl.style.display = 'block';
          if (emptyMessageEl) {
            emptyMessageEl.style.display = 'none';
            emptyMessageEl.textContent = '';
          }
        });
    } catch (e) {
      console.error('Error building invoice URL', e);
    }
  }

  function renderInvoices(list, type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    if (!tbody) return;

    if (!list || list.length === 0) {
      var message =
        type === 'offline'
          ? 'You do not have any in-store purchases yet.'
          : 'You do not have any online orders yet.';

      // Do not render an empty table row; just show the helper text below.
      tbody.innerHTML = '';

      if (emptyMessageEl) {
        emptyMessageEl.textContent = message;
        emptyMessageEl.style.display = 'block';
      }

      return;
    }

    tbody.innerHTML = '';

    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }

    list.forEach(function (item) {
      var tr = document.createElement('tr');
      var orderNumber = item.salesOrderNumber || '';
      var invoiceNumber = item.invoiceNumber || '';
      var purchaseDate = formatInvoiceDate(item.purchaseDate);
      var amount = item.paidAmount || '';
      var invoiceDate = formatInvoiceDate(item.invoiceDate);
      var url = item.invoiceUrl || '';

      tr.innerHTML =
        '<td>' + escapeHtml(orderNumber) + '</td>' +
        '<td>' + escapeHtml(invoiceNumber) + '</td>' +
        '<td>' + escapeHtml(purchaseDate) + '</td>' +
        '<td>' + escapeHtml(amount) + '</td>' +
        '<td>' + escapeHtml(invoiceDate) + '</td>' +
        '<td class="text-end">' +
        (url
          ? '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener" class="link-faded">View invoice</a>'
          : '') +
        '</td>';

      tbody.appendChild(tr);
    });
  }

  function formatInvoiceDate(raw) {
    if (!raw) return '';

    var value = String(raw).trim();

    // Handle explicit string patterns first so we don't let `new Date`
    // guess and potentially swap day & month for values like 11.03.2023.

    // Pattern like "27.12.2025" or "27.12.2025 20:24:02" (dd.MM.yyyy)
    var dotMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (dotMatch) {
      return dotMatch[1] + '/' + dotMatch[2] + '/' + dotMatch[3];
    }

    // Pattern like "2025-12-27" or "2025-12-27T15:00:25.995" (yyyy-MM-dd)
    var dashMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dashMatch) {
      return dashMatch[3] + '/' + dashMatch[2] + '/' + dashMatch[1];
    }

    // As a fallback, let the browser parse the date string if it can.
    var d = new Date(value);
    if (!isNaN(d.getTime())) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    // Last resort: return the original raw value
    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        default:
          return '&#39;';
      }
    });
  }
});

// -----------------------------------------------------------------------------
// ACCOUNT NAVIGATION (MOBILE HUB + DETAIL SCREENS)
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  var mobileQuery = window.matchMedia('(max-width: 999px)');
  var wrappers = document.querySelectorAll('.navigation--wrapper');
  if (!wrappers.length) return;

  function normalizePath(path) {
    return (path || '/').replace(/\/+$/, '') || '/';
  }

  function getShowParam() {
    try {
      return new URL(window.location.href).searchParams.get('show') || '';
    } catch (e) {
      return '';
    }
  }

  function isAccountHubPage() {
    return normalizePath(window.location.pathname) === '/account' && !getShowParam();
  }

  wrappers.forEach(function (wrapper) {
    var navShell = wrapper.querySelector('.account-navigation-shell');
    var nav = wrapper.querySelector('.account-navigation');
    if (!nav || !navShell) return;

    var contentNode = null;
    for (var i = 0; i < wrapper.children.length; i += 1) {
      var child = wrapper.children[i];
      if (
        !child.classList.contains('account-navigation') &&
        !child.classList.contains('account-navigation-shell')
      ) {
        contentNode = child;
        break;
      }
    }
    if (!contentNode) return;

    wrapper.classList.add('has-mobile-account-menu');
    contentNode.classList.add('account-mobile-content');

    contentNode.querySelectorAll('.account-mobile-back').forEach(function (backEl) {
      backEl.remove();
    });

    function syncAccountLinks() {
      wrapper.querySelectorAll('[data-mobile-account-href]').forEach(function (link) {
        var desktopHref = link.getAttribute('data-desktop-account-href') || '/account';
        var mobileHref = link.getAttribute('data-mobile-account-href') || desktopHref;
        link.href = mobileQuery.matches ? mobileHref : desktopHref;
      });
    }

    function syncAccountContentPanels() {
      if (normalizePath(window.location.pathname) !== '/account') return;

      var infoPanel = contentNode.querySelector('[data-account-panel="info"]');
      var mainPanel = contentNode.querySelector('[data-account-panel="main"]');
      if (!infoPanel || !mainPanel) return;

      var showParam = getShowParam();
      var showInfo = showParam === 'info';
      var showDetails = showParam === 'details';

      infoPanel.hidden = !showInfo;
      mainPanel.hidden = showInfo;

      mainPanel.querySelectorAll('[data-account-block-type]').forEach(function (blockEl) {
        if (showDetails) {
          var blockType = blockEl.getAttribute('data-account-block-type');
          blockEl.hidden = blockType !== 'account_details' && blockType !== 'primary_address';
        } else {
          blockEl.hidden = false;
        }
      });
    }

    function syncMobileView() {
      syncAccountContentPanels();

      if (!mobileQuery.matches) {
        wrapper.classList.remove('is-mobile-content-view', 'is-account-hub-view', 'is-account-info-view');
        syncAccountLinks();
        return;
      }

      syncAccountLinks();

      wrapper.classList.toggle('is-account-info-view', getShowParam() === 'info');

      if (isAccountHubPage()) {
        wrapper.classList.add('is-account-hub-view');
        wrapper.classList.remove('is-mobile-content-view');
      } else {
        wrapper.classList.remove('is-account-hub-view');
        wrapper.classList.add('is-mobile-content-view');
      }
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncMobileView);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncMobileView);
    }

    syncMobileView();
  });
});


// Customer coupons (account page): snippets/bestseller-coupon-shared.liquid + snippets/customer-coupons-account.liquid
// Cart coupons: snippets/cart-coupons.liquid

// MOBILE BARCODE SCANNER (HEADER SEARCH)
// -----------------------------------------------------------------------------

(function () {
  var MOBILE_BREAKPOINT = '(max-width: 699px)';
  var BARCODE_HOWTO_STORAGE_KEY = 'theme:barcode-scanner-howto-dismissed';
  var BARCODE_URL_PATTERN = /^(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\?variant=\d+$/i;
  var TRUSTED_SHORTENER_HOSTS = {
    'qrfy.io': true,
    'www.qrfy.io': true
  };
  var html5QrcodeScriptPromise = null;
  var jsQrScriptPromise = null;

  function joinRootPath(rootUrl, path) {
    var normalizedRoot = String(rootUrl || '/').replace(/\/+$/, '') + '/';
    var normalizedPath = String(path || '').replace(/^\/+/, '');
    return normalizedRoot + normalizedPath;
  }

  function normalizeSkuCandidate(rawValue) {
    var value = String(rawValue || '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/\s+/g, '')
      .trim();

    if (!value) return '';

    // Keep only common SKU characters from scanner payload noise.
    value = value.replace(/[^a-z0-9._-]/gi, '');
    if (!value || value.length < 6) return '';

    return value;
  }

  function extractHandleFromProductUrl(productUrl) {
    var url = String(productUrl || '');
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  }

  function toProductOnlyPath(productPathOrPayload) {
    var value = String(productPathOrPayload || '').trim();
    if (!value) return '';
    return value.split('?')[0].replace(/^\/+/, '');
  }

  function collectUrlCandidates(value) {
    var candidates = [];
    var seen = {};

    function addCandidate(candidate) {
      var clean = String(candidate || '').trim();
      if (!clean || seen[clean]) return;
      seen[clean] = true;
      candidates.push(clean);
    }

    function maybeDecode(candidate) {
      try {
        return decodeURIComponent(candidate);
      } catch (error) {
        return candidate;
      }
    }

    function addFromText(text) {
      var input = String(text || '').trim();
      if (!input) return;

      addCandidate(input);
      addCandidate(maybeDecode(input));

      var httpMatches = input.match(/https?:\/\/[^\s"'<>]+/gi) || [];
      httpMatches.forEach(addCandidate);

      var hostMatches = input.match(/(?:www\.)?jackjones\.in\/[^\s"'<>]+/gi) || [];
      hostMatches.forEach(function (item) {
        addCandidate(item);
        addCandidate('https://' + item.replace(/^https?:\/\//i, ''));
      });

      if (input.indexOf('?') > -1) {
        var queryString = input.split('?').slice(1).join('?');
        var params = new URLSearchParams(queryString);
        params.forEach(function (paramValue) {
          addCandidate(paramValue);
          addCandidate(maybeDecode(paramValue));
        });
      }
    }

    addFromText(value);
    return candidates;
  }

  function normalizeAbsoluteUrl(rawValue) {
    var value = String(rawValue || '').trim();
    if (!value) return null;

    try {
      value = decodeURIComponent(value);
    } catch (error) {
      // Keep original value if decodeURIComponent fails.
    }

    value = value
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/[\r\n\t]/g, '')
      .trim();

    if (!value) return null;

    if (/^www\./i.test(value)) {
      value = 'https://' + value;
    }

    try {
      if (/^(https?:)?\/\//i.test(value) || value[0] === '/') {
        return new URL(value, window.location.origin);
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function getTrustedShortenerUrl(rawValue) {
    var parsedUrl = normalizeAbsoluteUrl(rawValue);
    if (!parsedUrl) return null;

    var host = parsedUrl.hostname.toLowerCase();
    if (!TRUSTED_SHORTENER_HOSTS[host]) return null;

    if (!/^https?:$/i.test(parsedUrl.protocol)) return null;
    return parsedUrl.href;
  }

  function loadHtml5QrcodeScript() {
    if (window.Html5Qrcode) {
      return Promise.resolve(window.Html5Qrcode);
    }

    if (html5QrcodeScriptPromise) {
      return html5QrcodeScriptPromise;
    }

    html5QrcodeScriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/html5-qrcode@2.3.8/html5-qrcode.min.js';
      script.async = true;
      script.onload = function () {
        if (window.Html5Qrcode) {
          resolve(window.Html5Qrcode);
        } else {
          reject(new Error('Barcode library loaded but Html5Qrcode was unavailable.'));
        }
      };
      script.onerror = function () {
        reject(new Error('Unable to load barcode scanner library.'));
      };
      document.head.appendChild(script);
    });

    return html5QrcodeScriptPromise;
  }

  function loadJsQrScript() {
    if (window.jsQR) {
      return Promise.resolve(window.jsQR);
    }

    if (jsQrScriptPromise) {
      return jsQrScriptPromise;
    }

    jsQrScriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js';
      script.async = true;
      script.onload = function () {
        if (window.jsQR) {
          resolve(window.jsQR);
        } else {
          reject(new Error('Image QR decoder loaded but jsQR was unavailable.'));
        }
      };
      script.onerror = function () {
        reject(new Error('Unable to load gallery QR decoder.'));
      };
      document.head.appendChild(script);
    });

    return jsQrScriptPromise;
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(new Error('Unable to read selected image.'));
      };
      reader.readAsDataURL(file);
    });
  }

  function loadImageFromDataUrl(dataUrl) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () {
        resolve(image);
      };
      image.onerror = function () {
        reject(new Error('Unable to load selected image.'));
      };
      image.src = dataUrl;
    });
  }

  async function decodeFromImageWithJsQr(file) {
    await loadJsQrScript();

    var dataUrl = await readFileAsDataUrl(file);
    var image = await loadImageFromDataUrl(dataUrl);
    var maxDimension = 1800;
    var scale = Math.min(1, maxDimension / Math.max(image.width, image.height));
    var origWidth  = Math.max(1, Math.floor(image.width * scale));
    var origHeight = Math.max(1, Math.floor(image.height * scale));

    // Try all 4 rotations (0°, 90°, 180°, 270°) so sideways barcodes are detected
    var rotations = [0, 90, 180, 270];

    for (var r = 0; r < rotations.length; r++) {
      var angle = rotations[r];
      var isTransposed = angle === 90 || angle === 270;
      var canvasWidth  = isTransposed ? origHeight : origWidth;
      var canvasHeight = isTransposed ? origWidth  : origHeight;

      var canvas = document.createElement('canvas');
      canvas.width  = canvasWidth;
      canvas.height = canvasHeight;

      var context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) throw new Error('Unable to initialize image decoder.');

      context.save();
      context.translate(canvasWidth / 2, canvasHeight / 2);
      context.rotate((angle * Math.PI) / 180);
      context.drawImage(image, -origWidth / 2, -origHeight / 2, origWidth, origHeight);
      context.restore();

      var imageData = context.getImageData(0, 0, canvasWidth, canvasHeight);
      var result = window.jsQR(imageData.data, canvasWidth, canvasHeight, {
        inversionAttempts: 'attemptBoth'
      });

      if (result && result.data) {
        return result.data;
      }
    }

    return null;
  }

  function normalizeBarcodePayload(rawValue) {
    if (!rawValue) return null;

    var value = String(rawValue).trim();
    if (!value) return null;

    try {
      value = decodeURIComponent(value);
    } catch (error) {
      // Keep original value if decodeURIComponent fails.
    }

    // Remove invisible/control characters often found in generated QR text.
    value = value
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/[\r\n\t]/g, '')
      .trim();

    var candidates = collectUrlCandidates(value);

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i].split('#')[0].trim();
      if (!candidate) continue;

      if (/^www\./i.test(candidate)) {
        candidate = 'https://' + candidate;
      }

      var parsedUrl = null;
      try {
        if (/^(https?:)?\/\//i.test(candidate) || candidate[0] === '/') {
          parsedUrl = new URL(candidate, window.location.origin);
        } else if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(candidate)) {
          parsedUrl = new URL('https://' + candidate);
        }
      } catch (error) {
        parsedUrl = null;
      }

      var productPath = '';
      var variantId = '';

      if (parsedUrl) {
        productPath = parsedUrl.pathname.replace(/^\/+|\/+$/g, '');
        variantId = String(parsedUrl.searchParams.get('variant') || '').trim();
      } else {
        var parts = candidate.replace(/^\/+/, '').split('?');
        productPath = (parts[0] || '').replace(/\/+$/g, '');
        var params = new URLSearchParams(parts[1] || '');
        variantId = String(params.get('variant') || '').trim();
      }

      if (!/^\d+$/.test(variantId)) {
        continue;
      }

      if (!/^(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*$/i.test(productPath)) {
        continue;
      }

      var normalizedValue = productPath + '?variant=' + variantId;
      if (BARCODE_URL_PATTERN.test(normalizedValue)) {
        return normalizedValue;
      }
    }

    return null;
  }

  function getFriendlyErrorMessage(error) {
    var text = String(error && error.message ? error.message : error || '').toLowerCase();

    if (text.indexOf('permission') > -1 || text.indexOf('notallowederror') > -1 || text.indexOf('denied') > -1) {
      return 'Camera access is blocked. Please allow camera permission and try again.';
    }

    if (text.indexOf('notfounderror') > -1 || text.indexOf('no camera') > -1 || text.indexOf('camera not found') > -1) {
      return 'No camera was found on this device.';
    }

    if (text.indexOf('secure context') > -1 || text.indexOf('https') > -1) {
      return 'Barcode scanning requires a secure (HTTPS) storefront.';
    }

    return 'Unable to start scanner. Please try again.';
  }

  function MobileBarcodeScanner(modalElement) {
    this.modal = modalElement;
    this.statusElement = modalElement.querySelector('[data-barcode-status]');
    this.viewportElement = modalElement.querySelector('[data-barcode-viewport]');
    this.closeButton = modalElement.querySelector('[data-barcode-close]');
    this.galleryTriggerButton = modalElement.querySelector('[data-barcode-gallery-trigger]');
    this.galleryInput = modalElement.querySelector('[data-barcode-gallery-input]');
    this.manualOverlay = modalElement.querySelector('[data-barcode-manual-overlay]');
    this.manualInput = modalElement.querySelector('[data-barcode-manual-input]');
    this.manualError = modalElement.querySelector('[data-barcode-manual-error]');
    this.manualOpenButton = modalElement.querySelector('[data-barcode-manual-open]');
    this.manualCancelButton = modalElement.querySelector('[data-barcode-manual-cancel]');
    this.manualSubmitButton = modalElement.querySelector('[data-barcode-manual-submit]');
    this.manualBackdrop = modalElement.querySelector('[data-barcode-manual-backdrop]');
    this.galleryPreview = null;
    this.galleryStage = null;
    this.galleryImage = null;
    this.galleryHelp = null;
    this.galleryScanButton = null;
    this.galleryCancelButton = null;
    this.galleryPreviewFile = null;
    this.galleryImageObjectUrl = '';
    this.galleryPointerState = {};
    this.galleryZoom = {
      scale: 1,
      x: 0,
      y: 0
    };
    this.rootUrl = modalElement.getAttribute('data-root-url') || '/';
    this.scanner = null;
    this.isActive = false;
    this.isResolvingPayload = false;
    this.isManualOpen = false;
    this.noDetectionTimeout = null;
    this.earlyHintTimeout = null;
    this.rotationRescueInterval = null;
    this.lastFocusElement = null;
    this.allowDesktopBarcode = false;
    this.skuToUrlCache = {};
    this.onboardingOverlay = modalElement.querySelector('[data-barcode-onboarding]');
    this.onboardingContinueBtn = modalElement.querySelector('[data-barcode-onboarding-continue]');
    this.onboardingCloseModalBtn = modalElement.querySelector('[data-barcode-onboarding-close-modal]');

    if (!this.viewportElement.id) {
      this.viewportElement.id = 'barcode-viewport-' + Math.random().toString(36).slice(2);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    if (this.galleryTriggerButton && this.galleryInput) {
      this.galleryTriggerButton.addEventListener('click', function () {
        this.galleryInput.click();
      }.bind(this));

      this.galleryInput.addEventListener('change', this.onGalleryImageSelected.bind(this));
    }

    if (this.manualOpenButton) {
      this.manualOpenButton.addEventListener('click', this.openManualEntry.bind(this));
    }

    if (this.manualCancelButton) {
      this.manualCancelButton.addEventListener('click', this.closeManualEntry.bind(this));
    }

    if (this.manualSubmitButton) {
      this.manualSubmitButton.addEventListener('click', this.submitManualProductNumber.bind(this));
    }

    if (this.manualBackdrop) {
      this.manualBackdrop.addEventListener('click', this.closeManualEntry.bind(this));
    }

    if (this.manualInput) {
      this.manualInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.submitManualProductNumber();
        }
      }.bind(this));
    }

    this.modal.addEventListener('click', function (event) {
      if (event.target === this.modal) {
        this.close();
      }
    }.bind(this));

    if (this.onboardingContinueBtn) {
      this.onboardingContinueBtn.addEventListener(
        'click',
        function () {
          this.onHowToContinue();
        }.bind(this)
      );
    }

    if (this.onboardingCloseModalBtn) {
      this.onboardingCloseModalBtn.addEventListener(
        'click',
        function () {
          this.close();
        }.bind(this)
      );
    }

    this.ensureGalleryPreview();
  }

  MobileBarcodeScanner.prototype.setStatus = function (message, isError) {
    if (this.statusElement) {
      this.statusElement.textContent = message;
      if (isError) {
        this.statusElement.classList.add('barcode-scanner__status--error');
      } else {
        this.statusElement.classList.remove('barcode-scanner__status--error');
      }
    }
  };

  MobileBarcodeScanner.prototype.setManualError = function (message) {
    if (this.manualError) {
      this.manualError.textContent = message || '';
    }
  };

  MobileBarcodeScanner.prototype.clearManualError = function () {
    this.setManualError('');
  };

  MobileBarcodeScanner.prototype.openManualEntry = async function () {
    if (!this.manualOverlay || !this.manualInput) {
      return;
    }

    this.clearManualError();
    this.setStatus('');
    this.closeGalleryPreview();
    await this.stopScanner(true);
    this.modal.classList.add('barcode-scanner--manual-open');
    this.manualOverlay.removeAttribute('hidden');
    this.manualOverlay.setAttribute('aria-hidden', 'false');
    this.isManualOpen = true;
    this.manualInput.focus();
  };

  MobileBarcodeScanner.prototype.closeManualEntry = async function () {
    if (!this.manualOverlay || this.manualOverlay.hasAttribute('hidden')) {
      return;
    }

    this.manualOverlay.setAttribute('hidden', '');
    this.manualOverlay.setAttribute('aria-hidden', 'true');
    this.isManualOpen = false;
    this.modal.classList.remove('barcode-scanner--manual-open');
    this.clearManualError();
    if (this.manualInput) {
      this.manualInput.value = '';
    }

    if (!this.modal.hasAttribute('open')) {
      return;
    }

    if (!this.allowDesktopBarcode && !window.matchMedia(MOBILE_BREAKPOINT).matches) {
      return;
    }

    var self = this;

    async function tryStart() {
      await loadHtml5QrcodeScript();
      await self.startScanner();
    }

    try {
      await tryStart();
    } catch (error) {
      await new Promise(function (resolve) {
        setTimeout(resolve, 200);
      });
      try {
        await tryStart();
      } catch (retryError) {
        self.setStatus(getFriendlyErrorMessage(retryError), true);
      }
    }
  };

  MobileBarcodeScanner.prototype.submitManualProductNumber = async function () {
    if (this.isResolvingPayload) {
      return;
    }

    var raw = this.manualInput ? this.manualInput.value : '';
    this.clearManualError();

    var normalizedPath = normalizeBarcodePayload(raw);
    if (normalizedPath) {
      this.isResolvingPayload = true;
      try {
        await this.stopScanner();
        window.location.href = joinRootPath(this.rootUrl, toProductOnlyPath(normalizedPath));
      } finally {
        this.isResolvingPayload = false;
      }
      return;
    }

    var trustedShortenerUrl = getTrustedShortenerUrl(raw);
    if (trustedShortenerUrl) {
      this.isResolvingPayload = true;
      try {
        await this.stopScanner();
        window.location.href = trustedShortenerUrl;
      } finally {
        this.isResolvingPayload = false;
      }
      return;
    }

    var normalizedSku = normalizeSkuCandidate(raw);
    if (!normalizedSku) {
      this.setManualError('Enter a valid product number.');
      return;
    }

    this.isResolvingPayload = true;

    try {
      this.setStatus('Looking up product...');
      var productUrl = await this.resolveSkuToProductUrl(normalizedSku);

      if (productUrl) {
        if (navigator.vibrate) {
          navigator.vibrate(75);
        }
        await this.stopScanner();
        window.location.href = productUrl;
        return;
      }

      this.setManualError('No product found for this number.');
      this.setStatus('Point your camera at the barcode.');
    } finally {
      this.isResolvingPayload = false;
    }
  };

  MobileBarcodeScanner.prototype.shouldShowHowTo = function () {
    if (!this.onboardingOverlay) {
      return false;
    }
    try {
      return window.localStorage.getItem(BARCODE_HOWTO_STORAGE_KEY) !== '1';
    } catch (e) {
      return true;
    }
  };

  MobileBarcodeScanner.prototype.hideHowToOverlay = function () {
    if (!this.onboardingOverlay || this.onboardingOverlay.hasAttribute('hidden')) {
      return;
    }
    this.onboardingOverlay.setAttribute('hidden', '');
    this.onboardingOverlay.setAttribute('aria-hidden', 'true');
  };

  MobileBarcodeScanner.prototype.showHowToOverlay = function () {
    if (!this.onboardingOverlay) {
      return;
    }
    this.onboardingOverlay.removeAttribute('hidden');
    this.onboardingOverlay.setAttribute('aria-hidden', 'false');
  };

  MobileBarcodeScanner.prototype.beginCameraAfterOpen = async function () {
    var self = this;

    if (navigator.permissions) {
      navigator.permissions.query({ name: 'camera' }).then(function (result) {
        if (result.state !== 'granted') {
          self.setStatus('Requesting camera access...');
        }
      }).catch(function () {
        self.setStatus('Requesting camera access...');
      });
    } else {
      this.setStatus('Requesting camera access...');
    }

    try {
      await loadHtml5QrcodeScript();
      await this.startScanner();
    } catch (error) {
      this.setStatus(getFriendlyErrorMessage(error), true);
    }
  };

  MobileBarcodeScanner.prototype.onHowToContinue = async function () {
    try {
      window.localStorage.setItem(BARCODE_HOWTO_STORAGE_KEY, '1');
    } catch (e) {
      // Ignore private mode / blocked storage
    }
    this.hideHowToOverlay();
    await this.beginCameraAfterOpen();
  };

  MobileBarcodeScanner.prototype.open = async function (triggerElement, openOptions) {
    var forceDesktop = openOptions && openOptions.forceDesktop;
    this.allowDesktopBarcode = !!forceDesktop;
    if (!this.allowDesktopBarcode && !window.matchMedia(MOBILE_BREAKPOINT).matches) {
      return;
    }

    this.lastFocusElement = triggerElement || document.activeElement;
    this.closeGalleryPreview();
    this.modal.hidden = false;
    this.modal.setAttribute('open', '');
    document.body.style.overflow = 'hidden';

    if (this.manualOverlay) {
      this.manualOverlay.setAttribute('hidden', '');
      this.manualOverlay.setAttribute('aria-hidden', 'true');
      this.isManualOpen = false;
      this.modal.classList.remove('barcode-scanner--manual-open');
      this.clearManualError();
      if (this.manualInput) {
        this.manualInput.value = '';
      }
    }

    if (this.shouldShowHowTo()) {
      this.showHowToOverlay();
      return;
    }

    await this.beginCameraAfterOpen();
  };

  MobileBarcodeScanner.prototype.resolveSkuToProductUrl = async function (sku) {
    if (this.skuToUrlCache[sku]) {
      return this.skuToUrlCache[sku];
    }

    var query = encodeURIComponent(sku);
    var suggestUrl = joinRootPath(this.rootUrl, 'search/suggest.json') +
      '?q=' + query +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][fields]=title,product_type,tag,variants.sku,variants.barcode' +
      '&resources[options][unavailable_products]=last';

    var suggestResponse = await fetch(suggestUrl, { credentials: 'same-origin' });
    if (!suggestResponse.ok) {
      return null;
    }

    var suggestPayload = await suggestResponse.json();
    var products = suggestPayload &&
      suggestPayload.resources &&
      suggestPayload.resources.results &&
      Array.isArray(suggestPayload.resources.results.products)
      ? suggestPayload.resources.results.products
      : [];

    if (!products.length) {
      return null;
    }

    for (var i = 0; i < products.length; i += 1) {
      var product = products[i];
      var handle = product && product.handle ? product.handle : extractHandleFromProductUrl(product && product.url);
      if (!handle) {
        continue;
      }

      var productJsonUrl = joinRootPath(this.rootUrl, 'products/' + handle + '.js');
      var productResponse = await fetch(productJsonUrl, { credentials: 'same-origin' });
      if (!productResponse.ok) {
        continue;
      }

      var productPayload = await productResponse.json();
      var variants = productPayload && Array.isArray(productPayload.variants) ? productPayload.variants : [];
      var matchingVariant = variants.find(function (variant) {
        var variantSku = normalizeSkuCandidate(variant && variant.sku);
        var variantBarcode = normalizeSkuCandidate(variant && variant.barcode);
        return variantSku === sku || variantBarcode === sku;
      });

      if (matchingVariant && matchingVariant.id) {
        var resolvedUrl = joinRootPath(this.rootUrl, 'products/' + handle);
        this.skuToUrlCache[sku] = resolvedUrl;
        return resolvedUrl;
      }
    }

    return null;
  };

  MobileBarcodeScanner.prototype.handleDecodedText = async function (decodedText) {
    if (this.isResolvingPayload) {
      return false;
    }

    // Debounce: ignore if same barcode fires again within 2s
    var now = Date.now();
    if (this.lastDecodedText === decodedText && this.lastDecodeTime && (now - this.lastDecodeTime) < 2000) {
      return false;
    }
    this.lastDecodedText = decodedText;
    this.lastDecodeTime = now;

    // Vibrate on first successful decode for tactile feedback
    if (navigator.vibrate) {
      navigator.vibrate(150);
    }

    this.isResolvingPayload = true;

    try {
    var normalized = normalizeBarcodePayload(decodedText);
    if (!normalized) {
      var trustedShortenerUrl = getTrustedShortenerUrl(decodedText);
      if (trustedShortenerUrl) {
        this.setStatus('Barcode detected. Redirecting...');
        await this.stopScanner();
        window.location.href = trustedShortenerUrl;
        return true;
      }
    }

    if (!normalized) {
      var normalizedSku = normalizeSkuCandidate(decodedText);
      if (normalizedSku) {
        this.setStatus('Barcode detected. Finding product...');
        var productUrl = await this.resolveSkuToProductUrl(normalizedSku);
        if (productUrl) {
          this.setStatus('Product found. Redirecting...');
          if (navigator.vibrate) {
            navigator.vibrate(75);
          }
          await this.stopScanner();
          window.location.href = productUrl;
          return true;
        }
      }
    }

    if (!normalized) {
      var compactDecoded = String(decodedText || '').replace(/\s+/g, ' ').trim();
      if (compactDecoded.length > 70) {
        compactDecoded = compactDecoded.slice(0, 67) + '...';
      }
      this.setStatus('Invalid link scanned: "' + compactDecoded + '". Please scan a valid product tag.', true);
      return false;
    }

    this.setStatus('Barcode detected. Redirecting...');

    if (navigator.vibrate) {
      navigator.vibrate(75);
    }

    await this.stopScanner();
    window.location.href = this.rootUrl + toProductOnlyPath(normalized);
    return true;
    } finally {
      this.isResolvingPayload = false;
    }
  };

  MobileBarcodeScanner.prototype.onGalleryImageSelected = async function (event) {
    var file = event && event.target && event.target.files ? event.target.files[0] : null;
    if (!file) return;

    try {
      if (this.galleryTriggerButton) {
        this.galleryTriggerButton.disabled = true;
      }

      await this.stopScanner();
      this.openGalleryPreview(file);
    } catch (error) {
      this.setStatus('Could not detect a valid barcode in this image. Please try another photo.', true);
    } finally {
      if (this.galleryInput) {
        this.galleryInput.value = '';
      }
    }
  };

  MobileBarcodeScanner.prototype.scanGalleryPreviewFile = async function () {
    if (!this.galleryPreviewFile) return;

    try {
      await loadHtml5QrcodeScript();

      if (!window.Html5Qrcode) {
        throw new Error('Barcode scanner library is unavailable.');
      }

      if (!this.scanner) {
        this.scanner = new window.Html5Qrcode(this.viewportElement.id, {
          verbose: false,
          experimentalFeatures: {
            useBarCodeDetectorIfSupported: true
          }
        });
      }

      this.setStatus('Scanning selected image...');
      var decodedText = null;

      try {
        decodedText = await this.scanner.scanFile(this.galleryPreviewFile, true);
      } catch (scanError) {
        decodedText = await decodeFromImageWithJsQr(this.galleryPreviewFile);
      }

      this.closeGalleryPreview();

      if (!decodedText) {
        this.setStatus('Could not detect a valid barcode in this image. Please try another photo.', true);
        return;
      }

      await this.handleDecodedText(decodedText);
    } catch (error) {
      this.closeGalleryPreview();
      this.setStatus('Could not detect a valid barcode in this image. Please try another photo.', true);
    } finally {
      if (this.galleryTriggerButton) {
        this.galleryTriggerButton.disabled = false;
      }
    }
  };

  MobileBarcodeScanner.prototype.close = async function () {
    this.allowDesktopBarcode = false;
    this.closeGalleryPreview();
    await this.stopScanner();
    this.hideHowToOverlay();

    if (this.manualOverlay) {
      this.manualOverlay.setAttribute('hidden', '');
      this.manualOverlay.setAttribute('aria-hidden', 'true');
      this.isManualOpen = false;
      this.modal.classList.remove('barcode-scanner--manual-open');
      this.clearManualError();
      if (this.manualInput) {
        this.manualInput.value = '';
      }
    }

    this.modal.removeAttribute('open');
    this.modal.hidden = true;
    document.body.style.removeProperty('overflow');

    if (this.lastFocusElement && typeof this.lastFocusElement.focus === 'function') {
      this.lastFocusElement.focus();
    }
  };

  MobileBarcodeScanner.prototype.startScanner = async function () {
    var self = this;

    if (!window.Html5Qrcode) {
      throw new Error('Barcode scanner library is unavailable.');
    }

    if (!this.scanner) {
      this.scanner = new window.Html5Qrcode(this.viewportElement.id, {
        verbose: false,
        experimentalFeatures: {
          useBarCodeDetectorIfSupported: true
        }
      });
    }

    this.setStatus('Point your camera at the product barcode.');
    this.isActive = true;
    this.lastDecodedText = null;

    if (this.noDetectionTimeout) {
      clearTimeout(this.noDetectionTimeout);
    }
    if (this.earlyHintTimeout) {
      clearTimeout(this.earlyHintTimeout);
    }

    this.earlyHintTimeout = setTimeout(function () {
      if (self.isActive && !self.isResolvingPayload) {
        self.setStatus('Try better lighting or move the barcode closer.');
      }
    }, 5000);

    this.noDetectionTimeout = setTimeout(function () {
      if (self.isActive && !self.isResolvingPayload) {
        self.setStatus('No barcode detected yet. Move closer and try again.');
      }
    }, 15000);

    var formats = [];
    if (window.Html5QrcodeSupportedFormats) {
      var supportedFormats = window.Html5QrcodeSupportedFormats;
      [
        'EAN_13',
        'EAN_8',
        'UPC_A',
        'UPC_E',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'ITF',
        'CODABAR',
        'QR_CODE'
      ].forEach(function (formatName) {
        if (supportedFormats[formatName] !== undefined) {
          formats.push(supportedFormats[formatName]);
        }
      });
    }

    await this.scanner.start(
      { facingMode: 'environment' },
      {
        fps: 25,
        qrbox: function (viewfinderWidth, viewfinderHeight) {
          var width = Math.floor(viewfinderWidth * 0.96);
          var height = Math.floor(viewfinderHeight * 0.92);
          return { width: Math.max(width, 260), height: Math.max(height, 180) };
        },
        aspectRatio: 1.2,
        rememberLastUsedCamera: true,
        disableFlip: false,
        formatsToSupport: formats.length ? formats : undefined
      },
      async function (decodedText) {
        if (!self.isActive) return;
        await self.handleDecodedText(decodedText);
      },
      function () {
        // Ignore repeated decode misses.
      }
    );

    // Start rotation rescue — catches codes the main scanner misses due to orientation
    this.startRotationRescue();
  };

  MobileBarcodeScanner.prototype.startRotationRescue = function () {
    var self = this;

    if (this.rotationRescueInterval) {
      clearInterval(this.rotationRescueInterval);
    }

    this.rotationRescueInterval = setInterval(async function () {
      if (!self.isActive || self.isResolvingPayload) return;

      var video = self.viewportElement.querySelector('video');
      if (!video || video.readyState < 2) return;

      try {
        await loadJsQrScript();
        if (!window.jsQR) return;

        var vw = video.videoWidth;
        var vh = video.videoHeight;
        if (!vw || !vh) return;

        // Only try 90° and 270° — the main scanner already covers 0° and 180°
        var rotations = [90, 270];

        for (var r = 0; r < rotations.length; r++) {
          if (!self.isActive || self.isResolvingPayload) break;

          var angle = rotations[r];
          var canvas = document.createElement('canvas');
          canvas.width  = vh;
          canvas.height = vw;

          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) continue;

          ctx.save();
          ctx.translate(vh / 2, vw / 2);
          ctx.rotate((angle * Math.PI) / 180);
          ctx.drawImage(video, -vw / 2, -vh / 2, vw, vh);
          ctx.restore();

          var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          var result = window.jsQR(imageData.data, canvas.width, canvas.height, {
            inversionAttempts: 'attemptBoth'
          });

          if (result && result.data) {
            await self.handleDecodedText(result.data);
            break;
          }
        }
      } catch (e) {
        // Silently ignore frame capture errors
      }
    }, 600);
  };

  MobileBarcodeScanner.prototype.stopScanner = async function (destroyInstance) {
    if (this.noDetectionTimeout) {
      clearTimeout(this.noDetectionTimeout);
      this.noDetectionTimeout = null;
    }

    if (this.earlyHintTimeout) {
      clearTimeout(this.earlyHintTimeout);
      this.earlyHintTimeout = null;
    }

    if (this.rotationRescueInterval) {
      clearInterval(this.rotationRescueInterval);
      this.rotationRescueInterval = null;
    }

    this.isActive = false;

    if (!this.scanner) {
      return;
    }

    try {
      await this.scanner.stop();
    } catch (error) {
      // Stop can throw if scanner is already stopped.
    }

    try {
      await this.scanner.clear();
    } catch (error) {
      // Clear can throw when no stream was attached.
    }

    if (destroyInstance) {
      this.scanner = null;
    }
  };

  MobileBarcodeScanner.prototype.ensureGalleryPreview = function () {
    if (this.galleryPreview || !this.modal) {
      return;
    }

    var preview = document.createElement('div');
    preview.className = 'barcode-scanner__gallery-preview';
    preview.setAttribute('hidden', '');
    preview.innerHTML =
      '<div class="barcode-scanner__gallery-stage" data-barcode-gallery-stage>' +
      '  <img class="barcode-scanner__gallery-image" data-barcode-gallery-image alt="Selected barcode image" draggable="false">' +
      '</div>' +
      '<div>' +
      '  <p class="barcode-scanner__gallery-help text-sm" data-barcode-gallery-help>Use two fingers to zoom and drag the image.</p>' +
      '  <div class="barcode-scanner__gallery-actions">' +
      '    <button type="button" class="barcode-scanner__gallery-action barcode-scanner__gallery-action--cancel" data-barcode-gallery-cancel>Cancel</button>' +
      '    <button type="button" class="barcode-scanner__gallery-action barcode-scanner__gallery-action--scan" data-barcode-gallery-scan>Scan image</button>' +
      '  </div>' +
      '</div>';

    this.modal.querySelector('.barcode-scanner__panel').appendChild(preview);

    this.galleryPreview = preview;
    this.galleryStage = preview.querySelector('[data-barcode-gallery-stage]');
    this.galleryImage = preview.querySelector('[data-barcode-gallery-image]');
    this.galleryHelp = preview.querySelector('[data-barcode-gallery-help]');
    this.galleryCancelButton = preview.querySelector('[data-barcode-gallery-cancel]');
    this.galleryScanButton = preview.querySelector('[data-barcode-gallery-scan]');

    if (this.galleryCancelButton) {
      this.galleryCancelButton.addEventListener('click', this.closeGalleryPreview.bind(this));
    }

    if (this.galleryScanButton) {
      this.galleryScanButton.addEventListener('click', this.scanGalleryPreviewFile.bind(this));
    }

    this.bindGalleryGestures();
  };

  MobileBarcodeScanner.prototype.openGalleryPreview = function (file) {
    if (!this.galleryPreview || !this.galleryImage || !file) {
      return;
    }

    this.galleryPreviewFile = file;
    if (this.galleryImageObjectUrl) {
      URL.revokeObjectURL(this.galleryImageObjectUrl);
      this.galleryImageObjectUrl = '';
    }

    this.galleryImageObjectUrl = URL.createObjectURL(file);
    this.galleryImage.src = this.galleryImageObjectUrl;
    this.resetGalleryTransform();
    this.modal.classList.add('barcode-scanner--gallery-open');
    this.galleryPreview.removeAttribute('hidden');
    this.setStatus('Adjust image and tap "Scan image".');
  };

  MobileBarcodeScanner.prototype.closeGalleryPreview = function () {
    if (!this.galleryPreview || this.galleryPreview.hasAttribute('hidden')) {
      return;
    }

    this.galleryPreview.setAttribute('hidden', '');
    this.modal.classList.remove('barcode-scanner--gallery-open');
    this.galleryPreviewFile = null;
    this.resetGalleryTransform();

    if (this.galleryImage) {
      this.galleryImage.removeAttribute('src');
    }

    if (this.galleryImageObjectUrl) {
      URL.revokeObjectURL(this.galleryImageObjectUrl);
      this.galleryImageObjectUrl = '';
    }

    if (this.galleryTriggerButton) {
      this.galleryTriggerButton.disabled = false;
    }
  };

  MobileBarcodeScanner.prototype.resetGalleryTransform = function () {
    this.galleryPointerState = {
      pointers: {},
      pinchStartDistance: 0,
      pinchStartScale: 1,
      pinchStartX: 0,
      pinchStartY: 0
    };
    this.galleryZoom.scale = 1;
    this.galleryZoom.x = 0;
    this.galleryZoom.y = 0;
    this.applyGalleryTransform();
  };

  MobileBarcodeScanner.prototype.applyGalleryTransform = function () {
    if (!this.galleryImage) return;
    this.galleryImage.style.transform =
      'translate(' + this.galleryZoom.x + 'px, ' + this.galleryZoom.y + 'px) scale(' + this.galleryZoom.scale + ')';
  };

  MobileBarcodeScanner.prototype.bindGalleryGestures = function () {
    if (!this.galleryStage || !this.galleryImage) {
      return;
    }

    var self = this;
    var MIN_SCALE = 1;
    var MAX_SCALE = 5;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getTwoPointers(pointers) {
      var ids = Object.keys(pointers);
      if (ids.length < 2) return null;
      return [pointers[ids[0]], pointers[ids[1]]];
    }

    function distance(a, b) {
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function midpoint(a, b) {
      return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    }

    function clampPan() {
      var stageRect = self.galleryStage.getBoundingClientRect();
      var maxX = ((self.galleryZoom.scale - 1) * stageRect.width) / 2;
      var maxY = ((self.galleryZoom.scale - 1) * stageRect.height) / 2;
      self.galleryZoom.x = clamp(self.galleryZoom.x, -maxX, maxX);
      self.galleryZoom.y = clamp(self.galleryZoom.y, -maxY, maxY);
    }

    this.galleryStage.addEventListener('pointerdown', function (event) {
      if (self.galleryPreview && self.galleryPreview.hasAttribute('hidden')) return;
      self.galleryStage.setPointerCapture(event.pointerId);
      self.galleryPointerState.pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      self.galleryPointerState.lastPan = { x: event.clientX, y: event.clientY };

      var pair = getTwoPointers(self.galleryPointerState.pointers);
      if (pair) {
        self.galleryPointerState.pinchStartDistance = distance(pair[0], pair[1]);
        self.galleryPointerState.pinchStartScale = self.galleryZoom.scale;
        var mid = midpoint(pair[0], pair[1]);
        self.galleryPointerState.pinchStartMid = mid;
        self.galleryPointerState.pinchStartX = self.galleryZoom.x;
        self.galleryPointerState.pinchStartY = self.galleryZoom.y;
      }
    });

    this.galleryStage.addEventListener('pointermove', function (event) {
      if (self.galleryPreview && self.galleryPreview.hasAttribute('hidden')) return;
      if (!self.galleryPointerState.pointers[event.pointerId]) return;
      event.preventDefault();
      self.galleryPointerState.pointers[event.pointerId] = { x: event.clientX, y: event.clientY };

      var pair = getTwoPointers(self.galleryPointerState.pointers);
      if (pair) {
        var currentDistance = distance(pair[0], pair[1]);
        if (self.galleryPointerState.pinchStartDistance > 0) {
          var nextScale = self.galleryPointerState.pinchStartScale * (currentDistance / self.galleryPointerState.pinchStartDistance);
          self.galleryZoom.scale = clamp(nextScale, MIN_SCALE, MAX_SCALE);
          var currentMid = midpoint(pair[0], pair[1]);
          self.galleryZoom.x = self.galleryPointerState.pinchStartX + (currentMid.x - self.galleryPointerState.pinchStartMid.x);
          self.galleryZoom.y = self.galleryPointerState.pinchStartY + (currentMid.y - self.galleryPointerState.pinchStartMid.y);
        }
      } else if (self.galleryZoom.scale > 1 && self.galleryPointerState.lastPan) {
        self.galleryZoom.x += event.clientX - self.galleryPointerState.lastPan.x;
        self.galleryZoom.y += event.clientY - self.galleryPointerState.lastPan.y;
        self.galleryPointerState.lastPan = { x: event.clientX, y: event.clientY };
      }

      clampPan();
      self.applyGalleryTransform();
    }, { passive: false });

    function clearPointer(pointerId) {
      delete self.galleryPointerState.pointers[pointerId];
      self.galleryPointerState.lastPan = null;
      if (Object.keys(self.galleryPointerState.pointers).length < 2) {
        self.galleryPointerState.pinchStartDistance = 0;
      }
      if (self.galleryZoom.scale <= 1) {
        self.galleryZoom.scale = 1;
        self.galleryZoom.x = 0;
        self.galleryZoom.y = 0;
        self.applyGalleryTransform();
      }
    }

    this.galleryStage.addEventListener('pointerup', function (event) {
      clearPointer(event.pointerId);
    });
    this.galleryStage.addEventListener('pointercancel', function (event) {
      clearPointer(event.pointerId);
    });
    this.galleryStage.addEventListener('pointerleave', function (event) {
      clearPointer(event.pointerId);
    });

    this.galleryStage.addEventListener('wheel', function (event) {
      if (self.galleryPreview && self.galleryPreview.hasAttribute('hidden')) return;
      event.preventDefault();
      var delta = event.deltaY < 0 ? 0.2 : -0.2;
      self.galleryZoom.scale = clamp(self.galleryZoom.scale + delta, MIN_SCALE, MAX_SCALE);
      if (self.galleryZoom.scale <= 1) {
        self.galleryZoom.x = 0;
        self.galleryZoom.y = 0;
      } else {
        clampPan();
      }
      self.applyGalleryTransform();
    }, { passive: false });
  };

  var SEARCH_BAR_SCANNER_BTN_CLASS = 'header-search__barcode-adjoined-btn';
  var SEARCH_BAR_SCANNER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" ' +
    'd="M5 8V5h3M19 8V5h-3M5 16v3h3M19 16v3h-3M8 12h8"/>' +
    '</svg>';

  function observeBarcodeLibraryPreload(button) {
    if (!button || !('IntersectionObserver' in window)) return;
    var preloadObserver = new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) {
        loadHtml5QrcodeScript().catch(function () {});
        obs.disconnect();
      }
    }, { threshold: 0 });
    preloadObserver.observe(button);
  }

  function walkShadowSubtree(root, visit) {
    var queue = [root];
    while (queue.length) {
      var node = queue.shift();
      if (!node) continue;
      visit(node);
      if (node.shadowRoot) queue.push(node.shadowRoot);
      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          queue.push(node.children[i]);
        }
      }
    }
  }

  /** True once ViSenze has rendered a search surface (input or slot shell + height). */
  function viSenzeSearchSurfaceReady(widget) {
    if (!widget) return false;
    var hasInput = false;
    walkShadowSubtree(widget, function (node) {
      if (hasInput || !node || !node.tagName) return;
      var tag = node.tagName.toLowerCase();
      if (tag !== 'input') return;
      var type = (node.getAttribute('type') || 'text').toLowerCase();
      if (type === 'hidden' || type === 'file' || type === 'checkbox' || type === 'radio' || type === 'submit')
        return;
      hasInput = true;
    });
    if (hasInput) return true;

    var hasShell = false;
    walkShadowSubtree(widget, function (node) {
      if (hasShell || !node || typeof node.getAttribute !== 'function') return;
      var slot = node.getAttribute('data-slot');
      if (slot === 'main-wrapper' || slot === 'input-wrapper') hasShell = true;
    });
    var h = 0;
    try {
      h = widget.offsetHeight;
    } catch (e) {}
    return hasShell && h > 20;
  }

  function isCanvasAppWebView() {
    try {
      return /canvas/i.test(navigator.userAgent || '');
    } catch (e) {
      return false;
    }
  }

  /** Homepage strip + header inline: show adjoining barcode once ViSenze surface exists (.mobile-top-search-bar--viz-ready / .mobile-top-search-bar-inline--viz-ready). */
  function initMobileHomeTopSearchBarcodeReveal() {
    document.querySelectorAll('.mobile-top-search-bar.mobile-top-search-bar--with-barcode').forEach(function (strip) {
      var btn = strip.querySelector('.mobile-top-search-bar__barcode-outside');
      var widget =
        strip.querySelector('.mobile-top-search-bar__widget-cell.ps-widget-9350') || strip.querySelector('.ps-widget-9350');
      if (!btn || !widget) return;

      function reveal() {
        strip.classList.add('mobile-top-search-bar--viz-ready');
      }

      if (viSenzeSearchSurfaceReady(widget)) {
        reveal();
        return;
      }

      var attempts = 0;
      var maxAttempts = 120;
      var iv = setInterval(function () {
        attempts++;
        if (viSenzeSearchSurfaceReady(widget) || attempts >= maxAttempts) {
          clearInterval(iv);
          reveal();
        }
      }, 125);
    });

    document.querySelectorAll('.mobile-top-search-bar-inline.mobile-top-search-bar-inline--with-scanner').forEach(function (strip) {
      var btn = strip.querySelector('.mobile-top-search-bar-inline__barcode-outside');
      var widget =
        strip.querySelector('.mobile-top-search-bar-inline__widget.ps-widget-9350') || strip.querySelector('.ps-widget-9350');
      if (!btn || !widget) return;

      function reveal() {
        strip.classList.add('mobile-top-search-bar-inline--viz-ready');
      }

      if (viSenzeSearchSurfaceReady(widget)) {
        reveal();
        return;
      }

      var attempts = 0;
      var maxAttempts = 120;
      var iv = setInterval(function () {
        attempts++;
        if (viSenzeSearchSurfaceReady(widget) || attempts >= maxAttempts) {
          clearInterval(iv);
          reveal();
        }
      }, 125);
    });
  }

  function initViSenzeSearchBarcodeAdjoined(scannerMap) {
    var modalIds = Object.keys(scannerMap || {});
    if (!modalIds.length) return;

    function walkShadowTree(root, visit) {
      var queue = [root];
      while (queue.length) {
        var node = queue.shift();
        if (!node) continue;
        visit(node);
        if (node.shadowRoot) queue.push(node.shadowRoot);
        if (node.children) {
          for (var i = 0; i < node.children.length; i++) {
            queue.push(node.children[i]);
          }
        }
      }
    }

    function containsBarcodeScannerDeep(formControl) {
      var cls = SEARCH_BAR_SCANNER_BTN_CLASS;
      var found = false;
      walkShadowTree(formControl, function (node) {
        if (found) return;
        if (node && node.classList && node.classList.contains(cls)) found = true;
      });
      return found;
    }

    function collectEnhancementRoots() {
      var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
      var roots = [];

      function add(el) {
        if (!el) return;
        if (seen) {
          if (seen.has(el)) return;
          seen.add(el);
        }
        roots.push(el);
      }

      document.querySelectorAll('#predictive-search-form .header-search__form-control').forEach(add);
      document.querySelectorAll('.ps-widget-9350').forEach(add);

      return seen ? roots : roots.filter(function (el, i, arr) {
        return arr.indexOf(el) === i;
      });
    }

    function queryFileInputDeep(root) {
      var found = null;
      walkShadowTree(root, function (node) {
        if (found || !node.querySelector) return;
        try {
          var imageFile = node.querySelector(
            'input[type="file"][accept*="image"], input[type="file"][accept*="Image"], input[type="file"][accept*="jpg"], input[type="file"][accept*="png"]'
          );
          if (imageFile) found = imageFile;
          else {
            var anyFile = node.querySelector('input[type="file"]');
            if (anyFile) found = anyFile;
          }
        } catch (e) {
          /* ignore */
        }
      });
      return found;
    }

    function isLikelyCloseOrDismissButton(el) {
      if (!el || typeof el.getAttribute !== 'function') return true;
      var al = String(el.getAttribute('aria-label') || '').toLowerCase();
      var t = String(el.getAttribute('title') || '').toLowerCase();
      if (al.indexOf('close') !== -1 || t.indexOf('close') !== -1) return true;
      if (el.closest && el.closest('dialog-close-button')) return true;
      return false;
    }

    function findCameraHostBySvgButtons(formControl) {
      var candidates = [];
      walkShadowTree(formControl, function (node) {
        if (!node || !node.tagName) return;
        var tag = node.tagName.toLowerCase();
        var isBtn = tag === 'button' || node.getAttribute('role') === 'button';
        if (!isBtn || !node.querySelector || !node.querySelector('svg')) return;
        if (node.classList && node.classList.contains(SEARCH_BAR_SCANNER_BTN_CLASS)) return;
        if (isLikelyCloseOrDismissButton(node)) return;
        candidates.push(node);
      });
      if (!candidates.length) return null;
      var i;
      for (i = candidates.length - 1; i >= 0; i--) {
        var b = candidates[i];
        var al = String(b.getAttribute('aria-label') || '').toLowerCase();
        if (/image|photo|camera|picture|upload|lens|gallery|visenze/.test(al)) return b;
      }
      return candidates[candidates.length - 1];
    }

    function findCameraHost(formControl) {
      var fileIn = queryFileInputDeep(formControl);
      if (fileIn) {
        return fileIn.closest('button') || fileIn.closest('label') || fileIn.parentElement;
      }
      return findCameraHostBySvgButtons(formControl);
    }

    function enhanceFormControl(formControl) {
      if (!formControl) return;
      /* Homepage strip uses a Light DOM barcode control next to ViSenze — never inject inside that widget. */
      if (formControl.closest && formControl.closest('.mobile-top-search-bar')) return;
      /* Header inline ViSenze strip: no injected barcode (layout breaks in shadow UI; use homepage strip / search drawer). */
      if (formControl.closest && formControl.closest('.mobile-top-search-bar-inline-wrap')) return;
      /* Secondary nav: static scanner sibling next to ViSenze — do not inject inside widget. */
      if (formControl.closest && formControl.closest('.header__secondary-search-adjoined')) return;

      var deferNavEnhance =
        formControl.closest &&
        formControl.closest('.header__primary-nav') &&
        formControl.classList &&
        formControl.classList.contains('ps-widget-9350');
      if (deferNavEnhance && !viSenzeSearchSurfaceReady(formControl)) {
        var navTry = 0;
        (function waitForNavSurface() {
          navTry++;
          if (viSenzeSearchSurfaceReady(formControl)) {
            enhanceFormControl(formControl);
            return;
          }
          if (navTry < 120) {
            window.setTimeout(waitForNavSurface, 125);
          } else {
            enhanceFormControl(formControl);
          }
        })();
        return;
      }
      /* Light DOM query misses ViSenze content inside ShadowRoot — caused stacked duplicates on each mutation/scroll. */
      if (containsBarcodeScannerDeep(formControl)) return;

      if (!isCanvasAppWebView()) return;

      var cameraHost = findCameraHost(formControl);
      if (!cameraHost || cameraHost.closest('.' + SEARCH_BAR_SCANNER_BTN_CLASS)) return;
      if (cameraHost.closest && cameraHost.closest('.header-search__visual-icons-row')) return;

      var modalId = modalIds[0];
      var row = document.createElement('div');
      row.className = 'header-search__visual-icons-row';
      var cameraWrap = document.createElement('div');
      cameraWrap.className = 'header-search__visual-action header-search__visual-action--camera';

      var parent = cameraHost.parentNode;
      if (!parent) return;

      parent.insertBefore(row, cameraHost);
      cameraWrap.appendChild(cameraHost);

      var scannerBtn = document.createElement('button');
      scannerBtn.type = 'button';
      scannerBtn.className =
        'header-search__visual-action header-search__visual-action--scanner ' + SEARCH_BAR_SCANNER_BTN_CLASS;
      scannerBtn.setAttribute('data-barcode-scan-trigger', '');
      scannerBtn.setAttribute('aria-controls', modalId);
      scannerBtn.setAttribute('aria-haspopup', 'dialog');
      scannerBtn.setAttribute('aria-label', 'Scan barcode');
      scannerBtn.innerHTML = SEARCH_BAR_SCANNER_SVG;
      /* Scanner left of camera (matches storefront layout). */
      row.appendChild(scannerBtn);
      row.appendChild(cameraWrap);

      observeBarcodeLibraryPreload(scannerBtn);
    }

    var scanScheduled = false;
    function runEnhancementScan() {
      collectEnhancementRoots().forEach(enhanceFormControl);
    }

    function scheduleScan() {
      if (scanScheduled) return;
      scanScheduled = true;
      window.requestAnimationFrame(function () {
        scanScheduled = false;
        runEnhancementScan();
      });
    }

    var scanDebounceTimer = null;
    function scheduleScanDebounced() {
      if (scanDebounceTimer) window.clearTimeout(scanDebounceTimer);
      scanDebounceTimer = window.setTimeout(function () {
        scanDebounceTimer = null;
        scheduleScan();
      }, 320);
    }

    scheduleScan();
    [600, 2000].forEach(function (delayMs) {
      window.setTimeout(scheduleScan, delayMs);
    });
    var observer = new MutationObserver(function () {
      scheduleScanDebounced();
    });
    var moRoot =
      document.querySelector('.shopify-section--header') ||
      document.querySelector('x-header') ||
      document.body ||
      document.documentElement;
    observer.observe(moRoot, { childList: true, subtree: true });
  }

  function findViSenzeScannerIcon(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];

    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el instanceof Element && el.getAttribute && el.getAttribute('data-icon-type') === 'scanner') {
        return el;
      }
    }

    return null;
  }

  function initViSenzeScannerIconBridge(scannerMap) {
    var modalIds = Object.keys(scannerMap || {});
    if (!modalIds.length) return;

    document.addEventListener(
      'click',
      function (event) {
        var scannerIcon = findViSenzeScannerIcon(event);
        if (!scannerIcon) return;

        var scanner = scannerMap[modalIds[0]];
        if (!scanner) return;

        event.preventDefault();
        event.stopPropagation();

        scanner.open(scannerIcon, { forceDesktop: true });
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileHomeTopSearchBarcodeReveal();

    var scannerModals = document.querySelectorAll('[data-barcode-scanner-modal]');
    if (!scannerModals.length) return;

    var scannerMap = {};

    scannerModals.forEach(function (modal) {
      /* .shopify-section--header applies transform — fixed overlays stay inside that box and clip. */
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      scannerMap[modal.id] = new MobileBarcodeScanner(modal);
    });

    document.querySelectorAll('[data-barcode-modal-auto][data-barcode-scan-trigger]').forEach(function (btn) {
      var keys = Object.keys(scannerMap);
      if (keys.length && !btn.getAttribute('aria-controls')) {
        btn.setAttribute('aria-controls', keys[0]);
      }
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-barcode-scan-trigger]');
      if (!button) return;

      var scannerId = button.getAttribute('aria-controls');
      if (!scannerId) {
        var autoKeys = Object.keys(scannerMap);
        if (!button.hasAttribute('data-barcode-modal-auto') || !autoKeys.length) return;
        scannerId = autoKeys[0];
      }

      var scanner = scannerMap[scannerId];
      if (!scanner) return;

      var openOptions =
        button.classList.contains(SEARCH_BAR_SCANNER_BTN_CLASS) ? { forceDesktop: true } : undefined;

      scanner.open(button, openOptions);
    });

    document.querySelectorAll('[data-barcode-scan-trigger]').forEach(function (button) {
      if (!isCanvasAppWebView()) return;
      observeBarcodeLibraryPreload(button);
    });

    initViSenzeSearchBarcodeAdjoined(scannerMap);
    initViSenzeScannerIconBridge(scannerMap);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      var openScanners = Object.keys(scannerMap)
        .map(function (scannerId) {
          return scannerMap[scannerId];
        })
        .filter(function (scanner) {
          return scanner.modal.hasAttribute('open');
        });

      var scannerWithManual = openScanners.find(function (scanner) {
        return scanner.isManualOpen;
      });

      if (scannerWithManual) {
        event.preventDefault();
        scannerWithManual.closeManualEntry();
        return;
      }

      openScanners.forEach(function (scanner) {
        scanner.close();
      });
    });
  });
})();

// SHOW THE SCANNER ICON ONLY ON APP
(function () {
  const isCanvasApp = /canvas/i.test(navigator.userAgent);

  function walkShadowTree(root, callback) {
    if (!root) return;

    callback(root);

    if (root.shadowRoot) {
      walkShadowTree(root.shadowRoot, callback);
    }

    if (root.children) {
      Array.from(root.children).forEach(function (child) {
        walkShadowTree(child, callback);
      });
    }
  }

  function toggleScannerVisibility() {
    walkShadowTree(document, function (node) {
      if (
        node instanceof Element &&
        node.getAttribute?.("data-icon-type") === "scanner"
      ) {
        node.style.display = isCanvasApp ? "" : "none";
      }
    });
  }

  toggleScannerVisibility();

  const observer = new MutationObserver(toggleScannerVisibility);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
